import { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Card,
    Layout,
    Page,
    Button,
    Banner,
    Icon,
    ProgressBar,
    Text,
    Collapsible,
    Tooltip,
    BlockStack,
    ActionList,
    Popover,
    RadioButton,
    TextField,
    Spinner,
    Badge,
    Modal,

} from '@shopify/polaris';
import {
    ReferralMajor,
    DuplicateMinor,
    ChevronDownMinor,
    ChevronRightMinor,
    ChevronUpMinor,
    MobileHorizontalDotsMajor,
    CancelMajor,
    ChatMajor,
    CancelSmallMinor,
    LockMajor,
    CancelMinor,
    // EditMinor,
    ShareMinor,
    ComposeMajor,
    ViewMinor,

} from '@shopify/polaris-icons';
// import AppNotification from "../../../components/AppNotification";
import './indexv3.css';
import utils from '../../../utils/utils';
import SkeltonLoading from '../../../components/SkeltonLoading';
import NewHelpCenterIcon from '../../../assets/DashboardV2/NewHelpCenterIcon'
import ClearCodeIcon from '../../../assets/DashboardV2/ClearCodeIcon'
import { store } from '../../../redux/store';
//优惠翻窗
import StarIcon from '../../../assets/StarIcon';

import {
    reqUpdateCustomerClick,
    reqGetCheckScoreData,
    // reqHomeAdClick,
    reqReviewTipsClick,
    reqSaveSwitchState,
    reqGetSiteSpeedUp,
    reqCheckThemeAppExtension,
    reqAddAdsClickNum,
    reqPageSpeedWebsiteCheck,
    reqPostPageSpeedOnline,
    reqGetCannyPlugInSSO,
    reqGetFeedback,
    reqGetSpeedupData,
    reqDelCache,
    reqGetGuideCoupon,
    reqRefreshPageOnline,
    reqGetPageSpeedOnlineStatus,
    reqCheckWebStatus,

} from '../../../api';

// 引入 ECharts 主模块 / 仪表盘
import * as echarts from 'echarts/core';
import { GaugeChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { TooltipComponent } from 'echarts/components';
import { connect } from 'react-redux'
import { setSeoPageScoreData, saveStartReview, setSaveSwitchData, savePayTip } from '../../../redux/actions/getAppPublicData';
import { setPageData } from '../../../redux/actions/getAppPageData';

//轮播图
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/bundle'; // 公共引入轮播图样式
import SwitchAll from '../../../utils/switchState';
import Language from '../../../i18n/Language';
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import LightningIcon from '../../../assets/LightningIcon';
import SearchResource from '../../../assets/SearchResource';
import { PAGESPEED_KEY } from '../../../utils/utils';
// import Feedback from '../Canny/components/CannyFun';
import FaqCardBox from '../../../components/FaqCardBox';
import TutorialIcon from '../../../assets/DashboardV2/TutorialIcon';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Language;

let timerArr = [], timerArrPage = [], appArr = [], timePage = [], speedArr = [];

echarts.use([GaugeChart, CanvasRenderer, TooltipComponent]);

class dashboardClass extends Component {
    advApi = 'https://appapi.sealapps.net/api/v1/getDateShow?appId=11'
    state = {
        firstContentStepOne: 0,//同步产品图片状态(同步中2 未同步0 同步完成1)
        firstContentSysncProduct: 0,//同步产品图片数量

        firstContentStepTwo: 0,//优化产品图片状态(同步中2 未同步0 同步完成1)
        firstContentOptimizeAlt: 0,//优化产品图片数量

        firstContentApplyLoading: false,//优化按钮apply加载状态
        firstContentModal: false,//优化弹窗开关
        firstContentProgress: true,//是否显示进度条
        AllaltConditions: ["1"],

        productAlt: "%product_title% - %shopname%",

        tempShowReview: false,

        //Remove/Reactivate App按钮加载状态
        reactivateButtonLoading: false,
        removeButtonLoading: false,

        //删除App引入代码确认框状态
        confirmRemoveAppStatus: false,
        //显示删除按钮功能
        showRemoveButton: false,
        //元标签重复
        initLoading: false,
        removeLoading: false,
        is_duplicate: false,
        is_hasMetaTag: true,
        AppNotificationShow: false,
        premiumStatus: false,

        //传递到评星组件的好评开关
        goodRating: false,

        username: this.props.username, //用户名称
        timePeriod: new Date(), //时间段
        timePeriodString: '',
        // domain: '',
        value: '',

        //操作状态
        opreState: 0,
        loadingPage: true,

        totalIssuesCount: 0,
        EstimatedSavedTime: 0,
        isHasOptimiseLogs: false,
        websiteScore: 0,
        bulkEditAndAutoUpdateLogs: [], // 优化节约批量修改与自动日志
        EstimatedSavingDetails: '',

        //add SpeedScore
        SpeedScore: 0,
        SpeedScoreStatus: true,

        isSendData: true, //控制定时请求

        mySpeedScore: 0,
        myWebsiteScore: 0,
        myWebsiteIssues: 0, //错误数量
        refreshStatus: false,
        // isSuccess: true,
        isPlayAnimation: false,
        isNewUser: false,

        // 功能使用情况
        functionUsage: {
            'isJsonLD': 0,
            'isHtmlSiteMap': 0,
            'isAutoMetaTitleDesc': 0,
            'isAutoImageAlt': 0,
            'isStructuredData': 0,
            'isFixedErrors': 0,
            'isOptimiseAllPage': 0,
        },

        //当前选中
        class1: "Tabs_Dashboard_active-tab__3kw-b",
        CurrentlySelectedDiv: "class1",

        //优化图片文字
        imageButtonText: t("Optimize again"),

        //折扣弹窗
        showDiscountPopup: false,
        discountPopupData: [],

        openReview: false,

        //免费图片额度
        ImageFreeQuota: 150,
        imagesAll: 0,
        imagesUse: 0,
        imagesProportion: 0,
        //product额度
        productAll: 0,
        productUse: 0,
        productProportion: 0,
        level: 1,
        OnPagefreeQuota: 50,

        //优惠券数据
        showCouponData: false,

        // 全局设置数据
        dashboardData: this.props.dashboardData,

        current_PageSize: 5, // 表格条数

        // 引导列表
        currentSelected: 1, // 默认选择第一个tab
        journeyList1: {
            "SEOChecker": {
                "id": 1,
                "title": "SEO Checker",
                "tag": "Scan for all issues on your website",
                "desc": "SEO Checker evaluates your website's content, speed, and performance to provide you with tips to improve your search visibility.",
                "btn": "Scan Now",
                "url": "/website-check",
                "status": false,
            },
            "EmBed": {
                "id": 12,
                "title": "EmBed",
                "tag": "Enable app embed",
                "desc": "Many features within the SEOAnt App will not work until you've enabled app embed from our app.",
                "btn": "Enable app embed",
                "url": "",
                "status": false,
            },
            "SiteSpeedUp": {
                "id": 2,
                "title": "Google PageSpeed",
                "tag": "Speed up your store",
                "desc": "Optimize Google PageSpeed and improve website loading speed to increase traffic",
                "btn": "Speed up now",
                "url": "/speedOpt/site-speedup",
                "status": false,
            },
            "Bulk-editMetaTags": {
                "id": 3,
                "title": "Bulk-edit Meta Tags",
                "tag": "Set your Meta Tags rules",
                "desc": "Bulk edit meta tags to make it easier for search engines to find your pages.",
                "btn": "Set your Meta Tags rules",
                "url": "/searchAppearance/bulk-edit/manual-bulk-edit",
                "status": false,
            },
            "ImageOptimization": {
                "id": 4,
                "title": "Image Optimize",
                "tag": "Efficiently optimize all of your images at once",
                "desc": "Compress images, add ALT text and file names with one click. Use preset rules for quick reference.",
                "btn": "Scan Now",
                "url": "/speedOpt/PageSpeed",
                "status": false,
            },
            "OnPageSEO": {
                "id": 5,
                "title": "On-page SEO",
                "tag": "Using AI to optimize On-page SEO",
                "desc": "Scan and analyze on-page elements with AI writer to ensure they follow Google's recommended practices for optimal results.",
                "btn": "Scan Now",
                "url": "/on-page-seo",
                "status": false,
            },
        },
        journeyList: {
            // "EmBed": {
            //     "id": 4,
            //     "title": "EmBed",
            //     "tag": "Enable app embed",
            //     "desc": "Some important functions require the seoant extension to be installed before they can be used.",
            //     "btn": "Enable app embed",
            //     "url": "",
            //     "status": false,
            //     "img": "/ai/PointSaleChannel.png"
            // },
            "OptimizeImages": {
                "id": 1,
                "title": "Optimize images",
                "tag": "Optimize images",
                "desc": "By optimizing to reduce the file size of your images without sacrificing image quality, you can make your pages load faster!",
                "btn": "Optimize Now",
                "url": "/speedOpt/PageSpeed",
                "status": false,
                "img": "/ai/ImageToCompress.png"
            },
            "SiteSpeedUp": {
                "id": 2,
                "title": "Speed up your store",
                "tag": "Speed up your store",
                "desc": "Helps your website load faster with just one click",
                "btn": "Speed up now",
                "url": "/speedOpt/site-speedup",
                "status": false,
                "img": "/ai/WebsitPageSpeedUp.png"
            },
            "On-pageSEO": {
                "id": 3,
                "title": "Using AI to optimize On-page SEO",
                "tag": "Using AI to optimize On-page SEO",
                "desc": "Scan and analyze on-page elements with AI writer to ensure they follow Google's recommended practices for optimal results.",
                "btn": "Optimize Now",
                "url": "/on-page-seo",
                "status": false,
                "img": "/ai/UseAiOpt.png"
            },
            "MetaTags": {
                "id": 5,
                "title": "Learn bulk edit Meta Tags",
                "tag": "Learn bulk edit Meta Tags",
                "desc": "Bulk edit meta tags to make it easier for search engines to find your pages.",
                "btn": "Set Meta Tags rules",
                "url": "/searchAppearance/bulk-edit/manual-bulk-edit",
                "status": false,
                "img": "/ai/SetMetaTagsImg.png"
            },
        },
        storeData: store.getState(), // 远程状态
        isShowQuota: true, // 额度banner状态
        showGuideBlock: true, // 指南展示状态

        pcSpeedScore: 0, // pc速度分数
        mobileSpeedScore: 0, // 移动端速度分数

        imageDetailStatus: false, // 图片预览状态
        saveCost: -1, // 节省成本
        isEnableLoading: false,

        points_gift_all: 0,
        points_gift_use: 0,
        points_paid_all: 0,
        points_paid_use: 0,

        adverList: [], // 广告列表
        isShowReviewbanner: false, // 是否展示评价banner
        isBeforeShowBanner: true, // 前端判断
        isStartInx: 0,
        selectStartInx: 5, // 默认五星

        // 常见问题列表
        // frequentData: [
        //     {
        //         id: 'OnPageSEO',
        //         status: false, // 下拉状态
        //         title: "What is the quickest way to optimize the On-Page SEO?",
        //         desc: "SEOAnt has integrated with ChatGPT, allowing our AI writer to automatically generate content to help you resolve all of your On-Page SEO issues.",
        //         point: "AI writer",
        //     },
        //     {
        //         id: 'RankInGoogle',
        //         status: false, // 下拉状态
        //         title: "How does SEOAnt help me rank in Google?",
        //         desc: "The app continuously monitors and fixes your store to ensure that your SEO setup is compliant with Google's standards, saving you thousands of dollars in developer and SEO consultant fees.",
        //     },
        //     {
        //         id: 'AddCodeSEOant',
        //         status: false, // 下拉状态
        //         title: "Will SEOAnt add code to my store?",
        //         desc: "SEOAnt is designed as a set of independent add-ons that are fully compatible with any store, and will not add any code to your store.",
        //     },
        //     {
        //         id: 'UninstallSEOAnt',
        //         status: false, // 下拉状态
        //         title: "How do I uninstall SEOAnt completely?",
        //         desc: "Uninstalling SEOAnt from your apps list will completely remove all traces of the app from your store.",
        //     },
        //     {
        //         id: 'UnistallApp',
        //         status: false, // 下拉状态
        //         title: "If I uninstall the app, will my SEO still be optimized?",
        //         desc: "If the app is not suitable for your needs, you can uninstall it at any time. However, please note that some SEO optimizations will be deleted once you uninstall the app and your store will not be monitored for SEO fixes in the future.",
        //     },
        // ],
        questionList: {
            OnPageSEO: {
                title: "What is the quickest way to optimize the On-Page SEO?",
                tag: [
                    "SEOAnt has integrated with ChatGPT, allowing our AI writer to automatically generate content to help you resolve all of your On-Page SEO issues."
                ]
            },
            RankInGoogle: {
                title: "How does SEOAnt help me rank in Google?",
                tag: [
                    "The app continuously monitors and fixes your store to ensure that your SEO setup is compliant with Google's standards, saving you thousands of dollars in developer and SEO consultant fees."
                ]
            },
            AddCodeSEOant: {
                title: "Will SEOAnt add code to my store?",
                tag: [
                    "SEOAnt is designed as a set of independent add-ons that are fully compatible with any store, and will not add any code to your store."
                ]
            },
            UninstallSEOAnt: {
                title: "How do I uninstall SEOAnt completely?",
                tag: [
                    "Uninstalling SEOAnt from your apps list will completely remove all traces of the app from your store."
                ]
            },
            UnistallApp: {
                title: "If I uninstall the app, will my SEO still be optimized?",
                tag: [
                    "If the app is not suitable for your needs, you can uninstall it at any time. However, please note that some SEO optimizations will be deleted once you uninstall the app and your store will not be monitored for SEO fixes in the future."
                ]
            }
        },
        isShowAffiliateBanner: true, // AffiliateBanner状态
        ap_login_url: '', // 中台后台
        short_url: '',  // 分享链接
        isShowFeedback: false,  // 新手引导选项展开状态
        isShowGuideMain: false, // 新手引导展开状态
        isShowGuideBox: true, // 是否存在新手引导
        isShowGuideOld: true, // 是否展示旧新手引导
        isShowFeedbackBox: false, // 是否打开反馈box
        radioValue: '', // 反馈选项 
        feedbackValue: '', // 反馈
        faqUrl: '', // faq文档链接
        // allCount: -1, // 修复总数

        isShowGoogleWarn: false, // 是否打开google加速
        googleState: false, // 是否已经开启
        isShowToGoogle: false, // 是否展示按钮

        switch_data: {}, // 自定义缓存
        isCurrentShow: true, // 是否该次展示
        isShowFeedbackRes: false, // 是否展示反馈发送结果
        uid: 1, // 用户id
        isShowPageflyBanner: false, // 是否展示pagefly banner
        adverShowMore: false, // 广告更多
        isShowAdver: true, // 广告状态
        isCheckLoading: true,   // 刷新loading
        pageFlyState: 1,
        AppAdverList: [],
        adverInfo: this.props.adverInfo, // 广告数据
        adverloading: this.props.adverloading,
        RecheckButtonLoading: false,
        TopUrlContent: '', // 域名
        pendingData: [
            {
                id: 1, num: 0, desc: 'image alt texts need optimization', url: '/searchAppearance/image-alt-text',
            },
            {
                id: 2, num: 0, desc: 'images need optimization', url: '/speedOpt/PageSpeed',
            },
            {
                id: 3, num: 0, desc: 'broken links need fixing', url: '/backlinks/broken-link/view-errors',
            },
            {
                id: 4, num: 0, desc: 'pages are pending optimization', url: '/on-page-seo',
            },
            {
                id: 5, num: 0, desc: 'exchange requests for external links is pending', url: '/backlinks/exchange-backlink',
            },
        ], // 列表
        pendSvg: {
            "1": <svg width="16" height="8" viewBox="0 0 15 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.67798 0.928935C3.5539 0.667 3.29001 0.5 3.00018 0.5C2.71034 0.5 2.44645 0.667 2.32237 0.928935L0.0723726 5.67894C-0.104947 6.05328 0.0547707 6.50048 0.429111 6.6778C0.803452 6.85512 1.25066 6.69541 1.42798 6.32106L1.8169 5.5H4.18345L4.57237 6.32106C4.74969 6.69541 5.1969 6.85512 5.57124 6.6778C5.94558 6.50048 6.1053 6.05328 5.92798 5.67894L3.67798 0.928935ZM3.47292 4L3.00018 3.00198L2.52743 4H3.47292Z" fill="#4A4A4A" />
                <path d="M7.25018 0.75C7.6644 0.75 8.00018 1.08579 8.00018 1.5V5.25H9.50018C9.9144 5.25 10.2502 5.58579 10.2502 6C10.2502 6.41421 9.9144 6.75 9.50018 6.75H7.25018C6.83597 6.75 6.50018 6.41421 6.50018 6V1.5C6.50018 1.08579 6.83597 0.75 7.25018 0.75Z" fill="#4A4A4A" />
                <path d="M10.0002 0.75C9.58597 0.75 9.25018 1.08579 9.25018 1.5C9.25018 1.91421 9.58597 2.25 10.0002 2.25H11.0002V6C11.0002 6.41421 11.336 6.75 11.7502 6.75C12.1644 6.75 12.5002 6.41421 12.5002 6V2.25H13.5002C13.9144 2.25 14.2502 1.91421 14.2502 1.5C14.2502 1.08579 13.9144 0.75 13.5002 0.75H10.0002Z" fill="#4A4A4A" />
            </svg>,
            "2": <svg key={'icon-1'} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 6C10.3284 6 11 5.32843 11 4.5C11 3.67157 10.3284 3 9.5 3C8.67157 3 8 3.67157 8 4.5C8 5.32843 8.67157 6 9.5 6Z" fill="#4A4A4A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M6.0179 0.5H7.98211C8.79494 0.499993 9.45056 0.499987 9.98147 0.543364C10.5281 0.588026 11.0082 0.682385 11.4525 0.908726C12.1581 1.26825 12.7317 1.84193 13.0913 2.54754C13.3176 2.99175 13.412 3.4719 13.4566 4.01853C13.5 4.54944 13.5 5.20505 13.5 6.01788V7.98212C13.5 8.79496 13.5 9.45056 13.4566 9.98147C13.412 10.5281 13.3176 11.0082 13.0913 11.4525C12.7317 12.1581 12.1581 12.7317 11.4525 13.0913C11.0082 13.3176 10.5281 13.412 9.98147 13.4566C9.45056 13.5 8.79495 13.5 7.98212 13.5H6.01788C5.20505 13.5 4.54944 13.5 4.01853 13.4566C3.4719 13.412 2.99175 13.3176 2.54754 13.0913C1.84193 12.7317 1.26825 12.1581 0.908726 11.4525C0.682385 11.0082 0.588026 10.5281 0.543364 9.98147C0.499987 9.45056 0.499993 8.79495 0.5 7.98212V6.0179C0.499993 5.20506 0.499987 4.54944 0.543364 4.01853C0.588026 3.4719 0.682385 2.99175 0.908726 2.54754C1.26825 1.84193 1.84193 1.26825 2.54754 0.908726C2.99175 0.682385 3.4719 0.588026 4.01853 0.543364C4.54944 0.499987 5.20506 0.499993 6.0179 0.5ZM4.14068 2.03838C3.68681 2.07547 3.42604 2.1446 3.22852 2.24524C2.80516 2.46095 2.46095 2.80516 2.24524 3.22852C2.1446 3.42604 2.07547 3.68681 2.03838 4.14068C2.00058 4.60331 2 5.19755 2 6.05V7.4785L2.7228 6.61114C3.38159 5.82059 4.57697 5.76637 5.30462 6.49402L7.99999 9.18939L9.17963 8.00974C9.91716 7.27222 11.132 7.3395 11.7836 8.15396L11.9997 8.42404C12 8.27538 12 8.11768 12 7.95V6.05C12 5.19755 11.9994 4.60331 11.9616 4.14068C11.9245 3.68681 11.8554 3.42604 11.7548 3.22852C11.539 2.80516 11.1948 2.46095 10.7715 2.24524C10.574 2.1446 10.3132 2.07547 9.85932 2.03838C9.39669 2.00058 8.80245 2 7.95 2H6.05C5.19755 2 4.60331 2.00058 4.14068 2.03838ZM2.03838 9.85932C2.03622 9.83282 2.03417 9.80589 2.03225 9.7785C2.04743 9.76317 2.06209 9.74707 2.07615 9.73019L3.87513 7.57141C3.96924 7.45848 4.14001 7.45073 4.24396 7.55468L7.46966 10.7804C7.76255 11.0733 8.23742 11.0733 8.53032 10.7804L10.2403 9.0704C10.3457 8.96504 10.5192 8.97465 10.6123 9.09101L11.8252 10.6071C11.8037 10.6674 11.7803 10.7214 11.7548 10.7715C11.539 11.1948 11.1948 11.539 10.7715 11.7548C10.574 11.8554 10.3132 11.9245 9.85932 11.9616C9.39669 11.9994 8.80245 12 7.95 12H6.05C5.19755 12 4.60331 11.9994 4.14068 11.9616C3.68681 11.9245 3.42604 11.8554 3.22852 11.7548C2.80516 11.539 2.46095 11.1948 2.24524 10.7715C2.1446 10.574 2.07547 10.3132 2.03838 9.85932Z" fill="#4A4A4A" />
            </svg>,
            "3": <svg key={'icon-2'} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.8424 1.17566C11.3794 -0.287312 9.00745 -0.287312 7.54448 1.17566L5.4279 3.29224C3.9598 4.76034 3.96397 7.14187 5.4372 8.60482L5.77639 8.94164C6.07031 9.23351 6.54518 9.23184 6.83705 8.93793C7.12891 8.64401 7.12725 8.16914 6.83333 7.87727L6.49414 7.54045C5.6102 6.66268 5.6077 5.23376 6.48856 4.3529L8.60514 2.23632C9.48232 1.35913 10.9045 1.35913 11.7817 2.23632C12.6605 3.11508 12.6586 4.54041 11.7776 5.41693L10.7256 6.46356C10.432 6.7557 10.4308 7.23057 10.7229 7.52422C11.0151 7.81786 11.4899 7.81907 11.7836 7.52693L12.8356 6.4803C14.3049 5.01844 14.308 2.64127 12.8424 1.17566ZM1.17849 12.8456C2.64295 14.3101 5.01732 14.3101 6.48179 12.8456L8.60311 10.7243C10.0676 9.25986 10.0676 6.88549 8.60311 5.42102L8.2411 5.05901C7.9482 4.76611 7.47333 4.76611 7.18044 5.05901C6.88754 5.3519 6.88754 5.82677 7.18044 6.11967L7.54245 6.48168C8.42113 7.36036 8.42113 8.78498 7.54245 9.66366L5.42113 11.785C4.54245 12.6637 3.11783 12.6637 2.23915 11.785C1.36047 10.9063 1.36047 9.48168 2.23915 8.603L3.30812 7.53403C3.60101 7.24114 3.60101 6.76627 3.30812 6.47337C3.01522 6.18048 2.54035 6.18048 2.24746 6.47337L1.17849 7.54234C-0.285977 9.00681 -0.285977 11.3812 1.17849 12.8456Z" fill="#4A4A4A" />
            </svg>,
            "4": <svg key={'icon-3'} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M9.32264 10.3833C8.39957 11.0841 7.24835 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 7.24835 11.0841 8.39957 10.3833 9.32264L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L9.32264 10.3833ZM10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6Z" fill="#4A4A4A" />
            </svg>,
            "5": <svg key={'icon-4'} width="16" height="16" viewBox="0 0 31 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.0769 20.4265V15.8112H18.4615V12.7342H23.0769V8.11885H26.1538V12.7342H30.7692V15.8112H26.1538V20.4265H23.0769ZM13.8462 15.8112H7.69231C5.5641 15.8112 3.74974 15.0609 2.24923 13.5604C0.748719 12.0599 -0.00102459 10.246 1.05086e-06 8.11885C1.05086e-06 5.99065 0.750258 4.17629 2.25077 2.67578C3.75128 1.17526 5.56513 0.42552 7.69231 0.426545H13.8462V3.50347H7.69231C6.41026 3.50347 5.32051 3.95219 4.42308 4.84962C3.52564 5.74706 3.07692 6.8368 3.07692 8.11885C3.07692 9.4009 3.52564 10.4906 4.42308 11.3881C5.32051 12.2855 6.41026 12.7342 7.69231 12.7342H13.8462V15.8112ZM9.23077 9.65731V6.58039H21.5385V9.65731H9.23077ZM30.7692 8.11885H27.6923C27.6923 6.8368 27.2436 5.74706 26.3462 4.84962C25.4487 3.95219 24.359 3.50347 23.0769 3.50347H16.9231V0.426545H23.0769C25.2051 0.426545 27.0195 1.1768 28.52 2.67731C30.0205 4.17783 30.7703 5.99167 30.7692 8.11885Z" fill="#4A4A4A" />
            </svg>,
        },
        isShowQuotaPanel: false,
        websiteFuncList: {
            "SEO analysis": {
                "SEO checker": {
                    state: {},
                    field: "seo_checker",
                    type: "null",
                    url: "/website-check",
                    plan: 1,
                },
                "Google Analytics": {
                    state: {},
                    field: "google_analytics",
                    type: "switch",
                    url: "/searchAppearance/GoogleSearchConsoleV2",
                    plan: 2,
                },
                "Monitor the keywords of your website": {
                    state: {},
                    field: "my_keyword",
                    type: "switch",
                    url: "/keywordRearch/keywords-data",
                    plan: 2,
                },
                "Keyword Search": {
                    state: {},
                    field: "keyword_search",
                    type: "null",
                    url: "/keywordRearch/keywords-search",
                    plan: 1,
                },
                "Competitor Keywords Research": {
                    state: { status: false, quota: 0 },
                    field: "competitor_keywords_research",
                    type: "quota",
                    url: "/keywordRearch/keywords-monitor",
                    plan: 3,
                },
                "Keyword gap with competitors": {
                    state: {},
                    field: "keyword_comparison",
                    type: "switch",
                    url: "/keywordRearch/keywords-gap",
                    plan: 3,
                },
            },
            "Speed Optimization": {
                "Image Optimization": {
                    state: {},
                    field: "image_optimization",
                    type: "quota",
                    url: "/speedOpt/PageSpeed",
                    plan: 1,
                },
                "Site speed up": {
                    state: {},
                    field: "site_speed_up",
                    type: "switch",
                    url: "/speedOpt/site-speedup",
                    plan: 2,
                },
                "AMP": {
                    state: {},
                    field: "amp",
                    type: "switch",
                    url: "/speedOpt/seo-ant-amp",
                    plan: 3,
                },
                // "Instant Page": {
                //     state: {},
                //     field: "instant_page",
                //     type: "switch",
                //     url: "/speedOpt/instant-page",
                //     plan: 1,
                // },
            },
            "Content Optimization": {
                "On-page SEO Scan": {
                    state: {},
                    field: "on_page_seo",
                    type: "quota",
                    url: "/on-page-seo",
                    plan: 1,
                },
            },
            "Search Appearance": {
                "Meta Tags": {
                    state: {},
                    field: "meta_tags",
                    type: "switch",
                    url: "/searchAppearance/bulk-edit/manual-bulk-edit",
                    plan: 2,
                },
                "JSON-LD": {
                    state: {},
                    field: "json_ld",
                    type: "switch",
                    url: "/searchAppearance/structured-data",
                    plan: 2,
                },
                "Local Business": {
                    state: {},
                    field: "local_business",
                    type: "switch",
                    url: "/searchAppearance/local-business",
                    plan: 2,
                },
                "Instant Index": {
                    state: {},
                    field: "instant_index",
                    type: "switch",
                    url: "/searchAppearance/instant-index",
                    plan: 2,
                },
            },
            "Link Management": {
                "Broken links": {
                    state: {},
                    field: "broken_links",
                    type: "switch",
                    url: "/backlinks/broken-link/view-errors",
                    plan: 1,
                },
                "Backlink Audit": {
                    state: {},
                    field: "backlink_audit",
                    type: "switch",
                    url: "/backlinks/backlink-audit",
                    plan: 3,
                },
                "Exchange Backlink": {
                    state: {},
                    field: "exchange_backlink",
                    type: "quota",
                    url: "/backlinks/exchange-backlink",
                    plan: 1,
                },
                "HTML Sitemap": {
                    state: {},
                    field: "html_sitemap",
                    type: "switch",
                    url: "/backlinks/html-sitemap",
                    plan: 1,
                },
            },
        },  // 功能总览
        optImages: 0,
        repBrokenlinks: 0,
        importantIssues: 0, // seo问题数
        needImprove: 0,
        goodResult: 0,
        scanTime: '',
        exchangeUse: 0, // 额度
        exchangeAll: 0,
        exchangePro: 0,
        onpageUse: 0,
        onpageAll: 0,
        onpagePro: 0,
        imageUse: 0,
        imageAll: 0,
        imagePro: 0,

        isShowNewFunc: false, // 新功能展示状态
        ssoToken: '',
        isShowStatus: false,
        isShowFeedbackAll: false,
        newFuncList: [],  // 新功能列表
        FBLoading: true, // 反馈loading
        isShowFuncNums: false, // 新功能数量
        isShowGetQuota: false, // 显示额度弹窗
        isAnimate: false,
        isAddImageQuota: this.props.isAddImageQuota,
        isShowCompleteTip: true,       // 完成额度获取提示
        openVideo: false,
        isShowPend: false,          // 是否显示待办
        isShowWebSpeed: false,      // 是否显示网站优化
        isShowAionpageBanner: !true, // ai onpage
        isVideoAnimate: false,
        isGetGuideCoupon: false,        // 是否已领取折扣
        isGetGuideEffect: false,        // 是否已应用
        couponLoading: false,

        showTipModalStatus: false,
        themeAppExtensionUrl: "",
        isShowRecheck: false,
        isShowTask: false,              // 任务福利弹层

        passwordStatus: -1, // 密码开启状态
        isResetPageSpeed: false,    // 是否重置页面速度
    };

    componentDidMount() {
        this.checkThemeExtension(); // 先判断是否开启扩展
        this.getData(this.props.dashboardData); // 首页数据+卡片数据
        this.setEChartsData(this.props.dashboardData); // 设置图表
        // this.getUserComboByCard(this.props.dashboardData); // 目前不需要
        // this.initData(); // 获取当前时间段
        // this.formatAdverData(this.state.dashboardData.publicInit.ads_data); // 格式化广告数据
        // this.getPageSpeedStatus(); // 获取pagespeed状态 
        // this.getCannyPlugInSSO();
        this.getRecommandAppList(this.props.adverInfo); // 设置广告数据
        this.getFeedbackList();
        this.getPageSpeedOnlineStatus();        // 获取加速状态
        this.checkWebsiteState();
        try {
            let showState = sessionStorage.getItem("isShowCompleteTip");
            this.setState({
                isShowCompleteTip: !Boolean(showState)
            })
        } catch (e) { }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.dashboardData !== this.props.dashboardData) {
            this.setState({
                dashboardData: nextProps.dashboardData,
            }, () => {
                if (Boolean(nextProps.dashboardData.status)) {
                    this.getData(nextProps.dashboardData);
                    // 设置指南状态
                    this.setUserGuideStatusData(nextProps.dashboardData);
                }
            })
        }

        if (nextProps.isResetData !== this.props.isResetData) {
            this.setState({
                isResetData: nextProps.isResetData
            }, () => {
                if (Boolean(nextProps.dashboardData.status)) {
                    this.getData(nextProps.dashboardData);
                    // 设置指南状态
                    this.setUserGuideStatusData(nextProps.dashboardData);
                    // this.formatAdverData(nextProps.dashboardData.publicInit.ads_data);
                }
            })
        }

        if (nextProps.adverInfo !== this.props.adverInfo) {
            this.setState({
                adverInfo: nextProps.adverInfo,
            }, () => {
                this.getRecommandAppList(nextProps.adverInfo)
            })
        }
        if (nextProps.adverloading !== this.props.adverloading) {
            this.setState({
                adverloading: nextProps.adverloading,
            })
        }

        if (nextProps.isAddImageQuota !== this.props.isAddImageQuota) {
            this.setState({
                isAddImageQuota: nextProps.isAddImageQuota,
            })
        }

        return true;
    }

    // 获取 app || banner
    getRecommandAppList = (res) => {
        if (res?.ack === 1) {
            let newBanner = [];
            // banner
            if (res.data.rotate_popup && res.data.rotate_popup.length > 0) {
                res.data.rotate_popup.forEach(item => {
                    newBanner.push({
                        id: item.id,
                        title: item.app_name,
                        logo: item.img_url,
                        desc: item.desc,
                        url: item.jump_url,
                        btn: item?.button_text,
                    })
                })
                this.setState({
                    AppAdverList: newBanner
                }, () => {
                    const _store = this.props.public.appSwitch;
                    if (!Boolean(_store?.app_adver)) {
                        this.swiperReAppList();
                        // this.setState({
                        //     isShowPageflyBanner: true,
                        // }, () => {
                        // })
                    } else {
                        this.setState({
                            isShowPageflyBanner: false,
                        })
                    }
                })
            }

            // 应用广告
            if (res.data.list && res.data.list.length > 0) {
                this.formatAdverData(res.data.list); // 格式化广告数据
            }

        }
    }

    // 获取主题扩展状态
    checkThemeExtension = async () => {
        this.setState({
            isCheckLoading: true,
        })
        const res = await reqCheckThemeAppExtension();
        // let data = cloneDeep(this.state.journeyList);
        // data['EmBed']['status'] = Boolean(res.data?.status);
        if (res.code === 200) {
            this.setState({
                themeAppExtensionUrl: res.data.url,
                showTipModalStatus: !Boolean(res.data?.status),
                // journeyList: data,
                isCheckLoading: false,
            })
        }
    }

    // 获取pagespeed状态
    getPageSpeedStatus = async () => {
        const res = await reqGetSiteSpeedUp();
        if (res) {
            this.setState({
                googleState: !Boolean(res?.status),
            })
        }
    }

    // 指南
    setUserGuideStatusData = (data) => {
        let res = data.publicInit;
        if (Boolean(res.head_data?.switch_data?.manual_guide)) {
            let steps = res.head_data?.switch_data.manual_guide;
            let journeyData = cloneDeep(this.state.journeyList);
            // journeyData['EmBed']['status'] = journeyData['EmBed']['status'] ? true : Boolean(steps.seoant_core?.st);
            // journeyData['EmBed']['url'] = res.other_options.seoant_core_url || '';
            journeyData['OptimizeImages']['status'] = steps.img_comp.st;
            journeyData['SiteSpeedUp']['status'] = steps.speed_up.st;
            journeyData['On-pageSEO']['status'] = steps.page_opt.st;
            journeyData['MetaTags']['status'] = steps.meta_tag.st;
            let isAllin = Object.values(journeyData).filter(i => !Boolean(i.status));
            this.setState({
                journeyList: journeyData,
                isShowGetQuota: (Boolean(res.head_data?.switch_data?.dashboard_imgQuota) || isAllin.length > 0) ? false : true,
                isShowGuideMain: Boolean(isAllin.length === 0),
            }, () => {

                try {
                    // 是否完成新手引导和上传
                    if (window.shopify && this.state.isShowGetQuota && !Boolean(res.head_data?.switch_data?.complete_quick_guide)) {
                        this.requestStateSet('complete_quick_guide');
                        if (window.cio?.initialized) {
                            window.cio?.trigger({ event: 'complete_quick_guide' })
                        }
                    }
                } catch { }
            })
        } else {
            if (!Boolean(res.head_data?.switch_data?.manual_guide)) {
                setTimeout(() => {
                    this.setUserGuideStatusData(data);
                }, 500)
            }
        }
    }

    // 图表可视化
    setEChartsData = (data, isReset = false, isOnlySpeed = false) => {
        try {
            if (Boolean(document.getElementById('SEOScore')) && Boolean(document.getElementById('MobileScore')) && Boolean(document.getElementById('PCScore'))) {
                // 基于准备好的dom，初始化echarts实例
                let SEOScoreBox = Boolean(echarts.getInstanceByDom(document.getElementById('SEOScore'))) ? echarts.getInstanceByDom(document.getElementById('SEOScore')) : echarts.init(document.getElementById('SEOScore'));
                let MobileScoreBox = Boolean(echarts.getInstanceByDom(document.getElementById('MobileScore'))) ? echarts.getInstanceByDom(document.getElementById('MobileScore')) : echarts.init(document.getElementById('MobileScore'));
                let PCScoreBox = Boolean(echarts.getInstanceByDom(document.getElementById('PCScore'))) ? echarts.getInstanceByDom(document.getElementById('PCScore')) : echarts.init(document.getElementById('PCScore'));

                // 图表数据
                let scoreInfo = isReset ? data : data.publicInit.seo_data;
                // 左侧图表 -- 分数/颜色主题
                if (!isOnlySpeed) {
                    let seo_score = scoreInfo.seo_score.number;
                    let left_color = seo_score <= 60 ? '#e61523' : seo_score > 60 && seo_score <= 85 ? '#f3911e' : seo_score > 85 ? '#4fb681' : '#4fb681';
                    this.setLeftSEOScoreCharts(SEOScoreBox, seo_score, left_color);
                }
                // 右侧图表 -- 分数/颜色主题
                // 移动端
                let mobile_score = scoreInfo.speed_score.mobile.number;
                let mobile_color = mobile_score < 40 ? ['#ff3333', '#cc0000', '#ffeaea'] : mobile_score >= 40 && mobile_score < 60 ? ['#ffaa33', '#c33300', '#fff6ea'] : mobile_score >= 60 ? ['#00cc66', '#008800', '#e5faef'] : ['#ff3333', '#cc0000', '#ffeaea'];
                this.setRightGoogleMobileCharts(MobileScoreBox, mobile_score, mobile_color);
                // pc端
                let pc_score = scoreInfo.speed_score.desktop.number;
                let pc_color = pc_score < 50 ? ['#ff3333', '#cc0000', '#ffeaea'] : pc_score >= 50 && pc_score < 75 ? ['#ffaa33', '#c33300', '#fff6ea'] : pc_score >= 75 ? ['#00cc66', '#008800', '#e5faef'] : ['#ff3333', '#cc0000', '#ffeaea'];
                this.setRightGooglePCCharts(PCScoreBox, pc_score, pc_color);

                // 适配屏幕大小 重绘
                window.onresize = () => {
                    // 监听页面变化，改变表格宽度
                    SEOScoreBox.resize()
                    MobileScoreBox.resize()
                    PCScoreBox.resize()
                }
            } else {
                setTimeout(() => {
                    this.setEChartsData(this.props.dashboardData);
                }, 100)
            }
        } catch (e) {
            setTimeout(() => {
                this.setEChartsData(this.props.dashboardData);
            }, 500)
        }
    }

    // SEO Score 图表
    setLeftSEOScoreCharts = (target, data, colors) => {
        let gaugeData = [
            {
                value: Number((data / 100).toFixed(2)),
                // name: t("SCORE"),
            }
        ];
        // 设置参数
        target.setOption({
            series: [
                {
                    type: 'gauge',
                    radius: '170%',
                    startAngle: 180,
                    endAngle: 0,
                    center: ['50%', '85%'],
                    min: 0,
                    max: 1,
                    splitNumber: 8,
                    axisLine: {
                        lineStyle: {
                            width: 7,
                            color: [
                                [0.60, '#e61523'],
                                [0.85, '#f3911e'],
                                [1, '#4fb681'],
                            ]
                        },
                        roundCap: true,
                    },
                    pointer: {
                        icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                        length: '15%',
                        width: 10,
                        offsetCenter: [0, '-55%'],
                        itemStyle: {
                            color: 'auto'
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        length: 10,
                        lineStyle: {
                            color: 'auto',
                            width: 1
                        },
                    },
                    axisLabel: {
                        show: false,
                    },
                    title: {
                        offsetCenter: [0, '10%'],
                        fontSize: 15,
                        fontFamily: 'Inter', // 设置字体样式
                    },
                    detail: {
                        fontSize: 48,
                        fontFamily: 'Inter', // 设置字体样式
                        offsetCenter: [0, '-20%'],
                        valueAnimation: true,
                        color: colors,
                        formatter: function (value) {
                            return Math.round(value * 100) + '';
                        },
                    },
                    data: gaugeData
                }
            ]
        });
    }

    // 谷歌分数图表 移动端
    setRightGoogleMobileCharts = (target, data, colors) => {
        let gaugeData = [
            {
                value: data,
                name: t("Mobile"),
                detail: {
                    valueAnimation: true,
                    offsetCenter: ['0%', '6%']
                },
                title: {
                    offsetCenter: ['0%', '140%']
                },
            }
        ];
        // 设置参数
        target.setOption({
            series: [
                {
                    type: 'gauge',
                    radius: '70%',
                    center: ['50%', '45%'],
                    startAngle: 90,
                    endAngle: -270,
                    color: colors[0],
                    pointer: {
                        show: false
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                    },
                    axisLine: {
                        lineStyle: {
                            width: 7,
                            color: [[1, colors[2]]]
                        },
                    },
                    splitLine: {
                        show: false,
                        distance: 0,
                        length: 10
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false,
                        distance: 160
                    },
                    data: gaugeData,
                    title: {
                        fontSize: 14,
                        fontWeight: 450,
                        fontFamily: 'Inter', // 设置字体样式
                    },
                    detail: {
                        fontSize: 30,
                        fontFamily: 'Inter', // 设置字体样式
                        color: colors[1],
                    },
                }
            ]
        });
    }

    // 谷歌分数图表 PC端
    setRightGooglePCCharts = (target, data, colors) => {
        let gaugeData = [
            {
                value: data,
                name: t("Desktop"),
                detail: {
                    valueAnimation: true,
                    offsetCenter: ['0%', '6%']
                },
                title: {
                    offsetCenter: ['0%', '140%']
                },
            }
        ];
        // 设置参数
        target.setOption({
            series: [
                {
                    type: 'gauge',
                    radius: '70%',
                    center: ['50%', '45%'],
                    startAngle: 90,
                    endAngle: -270,
                    color: colors[0],
                    pointer: {
                        show: false
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                    },
                    axisLine: {
                        lineStyle: {
                            width: 7,
                            color: [[1, colors[2]]]
                        },
                    },
                    splitLine: {
                        show: false,
                        distance: 0,
                        length: 10
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false,
                        distance: 160
                    },
                    data: gaugeData,
                    title: {
                        fontSize: 14,
                        fontWeight: 450,
                        fontFamily: 'Inter', // 设置字体样式
                    },
                    detail: {
                        fontSize: 30,
                        fontFamily: 'Inter', // 设置字体样式
                        color: colors[1],
                    },
                }
            ]
        });
    }

    // 早中晚
    initData = () => {
        let num = new Date(this.state.timePeriod.getTime()).getHours() //获取当前小时
        if (num > 18) {
            this.timePeriodString = t("Good evening")
        } else if (num > 12) {
            this.timePeriodString = t("Good afternoon")
        } else if (num > 0) {
            this.timePeriodString = t("Good morning")
        }
        this.setState({ timePeriodString: this.timePeriodString });
    }

    // 获取数据
    getData = (dataAll) => {
        let res = dataAll;
        if (Boolean(dataAll.status)) {
            let that = res.publicInit;
            let switchData = res.publicInit.head_data?.switch_data;
            let isGoGuide = typeof switchData === 'boolean' ? true : (Boolean(switchData?.newbie_guide_page) ? Boolean(Number(switchData?.newbie_guide_page?.st) === 0) : false);
            let isGoPricing = typeof switchData === 'boolean' ? false : (Boolean(switchData?.select_version) ? Boolean(Number(switchData?.select_version?.st) === 0) : false);
            if (isGoGuide) {
                utils.routeJump(this, "/guide");
            } else {
                if (isGoPricing) {
                    utils.routeJump(this, "/plan");
                }
            }
            let timeState = res.publicInit.shop_data.created_at;
            let isOldGuide = true;
            if (Boolean(switchData?.manual_guide)) {
                if (Object.keys(switchData.manual_guide).length > 5) {
                    isOldGuide = false;
                }
            }

            let { pendingData, websiteFuncList } = this.state;

            // 计算pending数量
            let pData = cloneDeep(pendingData);
            pData[0].num = that.pending_data.image_un_alt;
            pData[1].num = that.pending_data.image_uncompressed;
            pData[2].num = that.pending_data.broken_link;
            pData[3].num = that.pending_data.seo_pending_opt;
            pData[4].num = that.pending_data.backlink;

            // 功能总览
            let websiteData = this.formatWebsiteData(websiteFuncList, that.func_use);

            // 关于额度
            const _q = that.meal_data;
            // 计算图片进度条
            let imagePro = Number(100 * ((Number(_q.images_use) + Number(_q?.img_usage_use || 0)) / (Number(_q.images_all) + Number(_q?.img_usage_all || 0))));
            // 计算onpage进度条
            let onpagePro = Number(100 * (_q.product_use / _q.product_all));
            // 计算外链互换进度条
            let exchangePro = Number(100 * (_q.backlink_use / _q.backlink_all));
            //更新状态
            this.setState({
                level: that.shop_data.level,
                loadingPage: false,
                TopState: Number(that.seo_data.seo_score.status), // seo_score 和 issue 状态 
                myWebsiteScore: Number(that.seo_data.seo_score.number), // seo_score分数
                SpeedScoreStatus: Number(that.seo_data.seo_score.status) ? false : true, // speed状态 
                pcSpeedScore: Number(that.seo_data.speed_score.desktop.number),// speed分数 pc
                mobileSpeedScore: Number(that.seo_data.speed_score.mobile.number),// speed分数 移动端
                // myWebsiteIssues: Number(that.seo_data.issues.number), // issue分数

                bulkEditAndAutoUpdateLogs: that.bulkEditAndAutoUpdateLogs,
                AppNotificationShow: (that.appNotification === 1) ? true : false,
                isSendData: (Number(that.seo_data.speed_score.status) && Number(that.seo_data.seo_score.status)) ? false : true,
                showCouponData: that.campaign_data,
                isShowReviewbanner: that.head_data.review_tips,
                ap_login_url: that.other_options.aps.ap_login_url,
                short_url: that.other_options.aps.short_url,
                optImages: Number(that.OptOverView_data.optimized_images), // 优化的图片数
                repBrokenlinks: Number(that.OptOverView_data.repaired_broken_link), // 修复链接数
                saveCost: Number(that.OptOverView_data.estimated_saved_cost), // 节省成本

                importantIssues: that.seo_data.seo_score.issues.important_issues,   // seo 问题数汇总
                needImprove: that.seo_data.seo_score.issues.needs_improvement,
                goodResult: that.seo_data.seo_score.issues.good_results,
                scanTime: this.formatUSATime(that.seo_data.seo_score.last_scan_time), // 扫描时间

                isShowGuideBox: timeState < 1698057000 ? false : typeof switchData === 'boolean' ? true : !Boolean(that.head_data?.switch_data?.dashboard_user_guide) && Boolean(that.head_data?.switch_data?.manual_guide),
                isShowGuideOld: isOldGuide,
                // currentSelected: isOldGuide ? 1 : 12,

                isShowPageflyBanner: typeof switchData === 'boolean' ? true : !Boolean(that.head_data?.switch_data?.dashboard_pagefly),
                isShowAffiliateBanner: typeof switchData === 'boolean' ? true : !Boolean(that.head_data?.switch_data?.dashboard_affiliate),
                isShowAdver: typeof switchData === 'boolean' ? true : !Boolean(that.head_data?.switch_data?.dashboard_adver),
                uid: that.shop_data.id,

                TopUrlContent: that.shop_data.domain,
                pendingData: pData,
                websiteFuncList: websiteData,
                // 额度
                exchangeUse: Number(_q.backlink_use),
                exchangeAll: Number(_q.backlink_all),
                exchangePro: Number((exchangePro > 100 ? 100 : exchangePro).toFixed(2)),
                onpageUse: Number(_q.product_use),
                onpageAll: Number(_q.product_all),
                onpagePro: Number((onpagePro > 100 ? 100 : onpagePro).toFixed(2)),
                imageUse: Number(_q.images_use) + Number(_q?.img_usage_use || 0),
                imageAll: Number(_q.images_all) + Number(_q?.img_usage_all || 0),
                imagePro: Number((imagePro > 100 ? 100 : imagePro).toFixed(2)),

                // 新功能数量
                isShowFuncNums: typeof switchData === 'boolean' ? true : (!Boolean(that.head_data?.switch_data?.newFuncNums) || Boolean(Number(that.head_data?.switch_data?.newFuncNums?.st) !== 1)),

                // 选择模块展示状态
                isShowPend: that.show_model.is_show_task,
                isShowWebSpeed: that.show_model.is_show_web_opt_view,

                // isShowAionpageBanner: typeof switchData === 'boolean' ? true : !Boolean(that.head_data?.switch_data?.dashboard_ai_onpage),
                isGetGuideCoupon: typeof switchData === 'boolean' ? false : Boolean(that.head_data?.switch_data?.get_guide_coupon),
                isGetGuideEffect: typeof switchData === 'boolean' ? false : Boolean(that.head_data?.switch_data?.get_guide_coupon?.st === 1),
            }, () => {
                //每5秒更新一次页面数据
                // 目前timerArrPage只存储该轮询接口
                if (this.state.isSendData && timerArrPage.length === 0) {
                    this.RefreshPageSpeedOnline();
                }

                if (this.state.isShowPageflyBanner) {
                    this.swiperReAppList();
                }

                // 设置指南状态
                this.setUserGuideStatusData(res);

                this.payTipToggle(that.shop_data.pricing_plan_id); // 判断是否提示支付成功
            });
        } else {
            this.props.toggleToast(res.msg, true);
            this.setState({
                myWebsiteScore: 0,
            })
        }


        // 清除浏览器链接上的参数
        try {
            var currentUrl = window.location.href;
            if (currentUrl.indexOf("?") !== -1) {
                currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, '');
                if (!!(window.history && window.history.pushState)) {
                    window.history.pushState({}, 0, currentUrl);
                }
            }
        } catch (error) {
            console.warn(error);
        }
    }

    // 格式化功能总览
    formatWebsiteData = (list, data) => {
        let compare = {
            "Link Management": "backlinks",
            "Content Optimization": "on_page_seo",
            "Search Appearance": "search_appearance",
            "SEO analysis": "seo_analysis",
            "Speed Optimization": "speed_optimization",
        }
        let websiteFuncData = cloneDeep(list);
        Object.keys(data).forEach(item => {
            Object.keys(websiteFuncData).forEach(objs => {
                if (item === 'on_page_seo') {
                    websiteFuncData["Content Optimization"]['On-page SEO Scan'].state = data[item];
                } else {
                    if (item === compare[objs]) {
                        Object.keys(data[item]).forEach(son => {
                            Object.keys(websiteFuncData[objs]).forEach(objSon => {
                                if (son === websiteFuncData[objs][objSon].field) {
                                    websiteFuncData[objs][objSon].state = data[item][son];
                                }
                            })
                        })
                    }
                }
            })
        })

        return websiteFuncData;
    }


    // 格式化时间戳
    formatUSATime = (time) => {
        // 创建一个新的 Date 对象，传入时间戳（秒为单位）
        var date = new Date(time * 1000);

        // 定义月份名称
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // 提取年、月、日、小时、分钟、上午/下午
        var year = date.getFullYear().toString();
        var month = monthNames[date.getMonth()];
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';

        // 将小时调整为 12 小时制
        hours = hours % 12;
        hours = hours ? hours : 12; // 如果 hours 为 0，则设为 12

        // 格式化分钟数为两位数
        minutes = minutes < 10 ? '0' + minutes : minutes;

        // 组合成指定格式的字符串
        var formattedDate = t(month) + ' ' + (day < 10 ? '0' + day : day) + ', ' + (year.slice(2)) + ' ' + hours + ':' + minutes + ' ' + ampm;
        return formattedDate;
    }

    // 轮播推广app
    swiperReAppList = () => {
        if (appArr.length === 0) {
            let timer = setInterval(() => {
                let { pageFlyState, AppAdverList } = this.state;
                this.setState({
                    pageFlyState: pageFlyState === AppAdverList.length ? 1 : pageFlyState + 1
                })
            }, 5000)
            appArr.push(timer)
        }
    }
    // 清除定时器
    clearAppArray = () => {
        appArr.map(timer => {
            clearInterval(timer);
            appArr.pop();
            return false;
        })
    }

    /**** add 检查站点优化数据 ***/
    RefreshPageSpeedOnline = () => {
        this.setState({ refreshStatus: true }, async () => {
            const res = await reqGetCheckScoreData();
            if (res.ack === 1) {
                timerArrPage.push('RefreshPageSpeedOnline');
                let that = res.data;
                this.props.setSeoData(that.seo_data); // 设置更新缓存
                this.setState({
                    TopState: Number(that.seo_data.seo_score.status), // seo_score 和 issue 状态 
                    myWebsiteScore: Number(that.seo_data.seo_score.number), // seo_score分数
                    SpeedScoreStatus: Number(that.seo_data.seo_score.status) ? false : true, // speed状态 
                    pcSpeedScore: Number(that.seo_data.speed_score.desktop.number),// speed分数 pc
                    mobileSpeedScore: Number(that.seo_data.speed_score.mobile.number),// speed分数 移动端
                    myWebsiteIssues: Number(that.seo_data.issues.number), // issue分数
                    isSendData: (Number(that.seo_data.speed_score.status) && Number(that.seo_data.seo_score.status)) ? false : true,
                }, () => {
                    this.setEChartsData(that.seo_data, true);
                    if (!(Boolean(that.seo_data.speed_score.status) && Boolean(that.seo_data.seo_score.status))) {
                        setTimeout(() => {
                            this.RefreshPageSpeedOnline();
                        }, 5000)
                    }
                })
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    };

    // 格式化广告数据
    formatAdverData = (data) => {
        // let advers = data.card_ad;
        let listAll = [];
        // let newList = cloneDeep(advers.banner);
        // let appList = cloneDeep(advers.list);
        // if(appList.length > 0) {
        //     appList = shuffleArrayData(appList); // 打乱排序
        // }
        let newList = [];
        let appList = cloneDeep(data);
        let lens = 4;
        if (newList.length <= 0) {
            if (appList.length > 0) {
                for (let i = 0; i < Math.ceil(appList.length / lens); i++) {
                    listAll.push({
                        list: []
                    })
                }
                for (let i = 1; i < Math.ceil((listAll.length * lens) / data.length); i++) {
                    appList = [...appList, ...data];
                }
                listAll.forEach((item, index) => {
                    item['list'] = appList.filter((list, inx) => inx < (index + 1) * lens && inx >= (index) * lens);
                })
            } else {
                listAll = [];
            }
        } else {
            if (appList.length > 0) {
                // 判断banner和app数量大小
                if (newList.length < appList.length / lens) {
                    // banner大于app
                    for (let i = 1; i < data.length / lens; i++) {
                        newList = [...newList, ...JSON.parse(JSON.stringify([].slice(0, Math.ceil(data.length / lens) - newList.length)))];
                        appList = [...appList, ...data];
                    }
                } else if (newList.length > appList.length / lens) {
                    // 循环复制app列表次数
                    for (let i = 1; i < Math.ceil((newList.length * lens) / data.length); i++) {
                        appList = [...appList, ...data];
                    }
                }
                newList.forEach((item, index) => {
                    item['list'] = appList.filter((list, inx) => inx < (index + 1) * lens && inx >= (index) * lens);
                })
                listAll = newList;
            } else {
                listAll = newList;
            }
        }
        this.setState({
            adverList: listAll
        })
    }

    // 支付提示弹窗
    payTipToggle = debounce((ppid = 1) => {
        // 等语言出来
        let _store = store.getState().public;
        if (_store.Language !== '') {
            // 判断是否支付回调地址
            if (_store.publicInit.other_options.paid_confirm === 1 && _store.payTipStatus === 0) {
                setTimeout(() => {
                    this.props.toggleToast(t("Payment successful"), false);
                    this.props.changePayTipStatus(1);
                    this.delApiCache(_store.publicInit.shop_data.id, ppid);
                }, 500)
            }
        } else {
            setTimeout(() => {
                this.payTipToggle();
            }, 500)
        }
    }, 500)

    // 清除缓存
    delApiCache = async (id, ppid) => {
        let params = {
            key: `seoant_paid_confirm_${id}`
        }
        const res = await reqDelCache(params);
        if (res.ack === 1) {
            // 更新公共数据
            this.props.setPayTipState(0);
        }
    }

    // 下拉常见问题列表
    handleColStatus = (val) => {
        let list = cloneDeep(this.state.frequentData);
        list.forEach(item => {
            if (item.title === val.title) {
                item.status = !val.status;
            }
        })

        this.setState({
            frequentData: list,
        })
    }

    //点击联系客服
    handleContactService = async (content) => {
        // window.$crisp.push(["do", "chat:open"])
        try {
            if (content === "Contact Us") {
                // window.$crisp.push(["set", "message:text", ['Hi, could you please help me with the problem of "Duplicate Meta Title & Description"?']])
                showNewMessage('Hi, could you please help me with the problem of "Duplicate Meta Title & Description"?')
            } else if (content === "Submit Sitemap") {
                // window.$crisp.push(["set", "message:text", ["I need help to submit Sitemap"]])
                showNewMessage('I need help to submit Sitemap')
            } else if (content === "Clear Code") {
                // window.$crisp.push(["set", "message:text", ["I need help to clear the code left"]])
                showNewMessage('I need help to clear the code left')
            } else if (content === "Issues Fixing") {
                // window.$crisp.push(["set", "message:text", ["I need help to fix SEO APP conflict issues"]])
                showNewMessage('I need help to fix SEO APP conflict issues')
            } else if (content === "SEO Suggestions") {
                // window.$crisp.push(["set", "message:text", ["I need some SEO suggestions for website"]])
                showNewMessage('I need some SEO suggestions for website')
            } else if (content === "Feature") {
                // window.$crisp.push(["set", "message:text", ["I am wondering if the app has this feature or in the future"]])
                showNewMessage('I am wondering if the app has this feature or in the future')
            } else if (content === "on-page products") {
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "on-page products" quota for me?']])
                showNewMessage('Hi,Can you increase the "on-page products" quota for me?')
            } else if (content === "image compression") {
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "image compression" quota for me?']])
                showNewMessage('Hi,Can you increase the "image compression" quota for me?')
            } else if (content === "image on-page compression") {
                // window.$crisp.push(["set", "message:text", ['Hi,Can you increase the "image compression" quota for me?']])
                showNewMessage('Hi,Can you increase the "image compression" and “On-Page SEO Product” quota for me?')
            } else { 
                showNewMessage();
            }
            const params = {
                'path': window.location.pathname,
                'content': content
            };
            await reqUpdateCustomerClick(params);
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 帮助模块
    handleHelpBlock = (type) => {
        if (type === 'tutorial_video') {
            this.setState({
                openVideo: true
            })
        } else if (type === 'chat_support') {
            this.handleContactService();
        } else if (type === 'help_center') {
            window.open("https://www.seoant.com/blog/all");
        } else if (type === 'feature') {
            utils.routeJump(this, '/dashboard/Feedback')
        } else if (type === 'clear_code') {
            this.handleContactService("Clear Code");
        } else if (type === 'feature_request') {
            utils.routeJump(this, '/dashboard/Feedback')
        } else { }
    }

    // 跳转外部链接
    jumpTargetUrl = (id, url) => {
        // reqHomeAdClick({ ad_id: id });
        window.open(url);
        this.addClickNums(id);
    }

    // 跳转推荐app详情页
    jumpAppRecommand = () => {
        utils.routeJump(this, "/dashboard/integration");
    }

    // 关闭新手引导
    handleDismiss = (type) => {
        this.setState({
            isShowGuideBox: false,
        }, async () => {
            this.requestStateSet(type);
        })
    }

    // 打开/关闭反馈
    openGiveFeedbackBox = () => {
        this.setState({
            isShowFeedbackBox: !this.state.isShowFeedbackBox,
            isShowFeedback: false,
        }, () => {
            // 如果是取消
            if (!this.state.isShowFeedbackBox) {
                this.setState({
                    radioValue: '',
                    feedbackValue: '',
                })
            }
        })
    }

    // 关闭完成反馈box
    closeFinishFeedback = () => {
        this.setState({
            isShowFeedbackRes: false,
            isShowFeedbackBox: false,
            radioValue: '',
            feedbackValue: '',
        })
    }

    // 打开新手引导选项
    changeGuideSet = () => {
        this.setState({
            isShowFeedback: !this.state.isShowFeedback,
        })
    }

    // 展开伸缩新手引导
    handleGuideMain = () => {
        this.setState({
            isShowGuideMain: !this.state.isShowGuideMain,
        })
    }

    // 单选
    handleRadioChange = (_, v) => {
        this.setState({
            radioValue: v,
        })
    }

    // 输入反馈
    handleFeedbackChange = (e) => {
        this.setState({
            feedbackValue: e,
        })
    }

    // 打开新手引导对应内容
    openGuideItem = (id) => {
        this.setState({
            currentSelected: id
        })
    }

    // 改变完成状态
    changeFinishState = (e, data) => {
        // e.stopPropagation();
    }

    // 跳转对应页面
    jumpToPage = (url, type = 'inner') => {
        let { isGetGuideCoupon } = this.state;
        if (url !== '') {
            if (type === 'out') {
                window.open(url)
            } else if (type === 'tip' && isGetGuideCoupon) {
                utils.routeJump(this, url, null, "showPopover");
            } else {
                utils.routeJump(this, url);
            }
        } else {
            this.props.toggleToast("Link doesn't exist", true);
        }
    }

    // 评价
    setReview = (n) => {
        this.setState({
            isShowReviewbanner: false,
            isBeforeShowBanner: false,
            isCurrentShow: false,
        }, async () => {
            this.props.setStartReview(false);
            if (window?.ratingOpera) {
                window.ratingOpera.ratingChanged(n, '', true)
            }
            const params = { score: n }
            await reqReviewTipsClick(params);
        })
    }

    // 进入
    mouseEnterReview = (n) => {
        this.setState({
            isStartInx: n,
        })
    }

    // 离开
    mouseLeaveReview = (n) => {
        this.setState({
            isStartInx: 0
        })
    }

    // 复制链接
    copyAfUrl = () => {
        this.props.toggleToast(t("Copy successfully!"), false);
        utils.CopyText(this.state.short_url);
    }

    // 打开对应程序
    openAppAction = (type) => {
        let url = this.state.short_url;
        // 脸书
        if (type === 'facebook') {
            let iWidth = 650;
            let iHeight = 700;
            let iTop = (window.screen.availHeight - 30 - iHeight) / 2;
            let iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
            let targetUrl = `https://facebook.com/sharer/sharer.php?u=${url}`;
            window.open(targetUrl, 'about:blank', 'height=' + iHeight + ',,innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no');
        }
    }

    // 关闭状态 公共
    closePublicState = (type = '') => {
        this.setState({
            isShowToGoogle: true,
        }, () => {
            if (type) {
                this.requestStateSet(type)
            }
        })
    }

    // 发送反馈
    sendFeedbackData = () => {
        this.setState({
            isShowFeedbackRes: true,
        }, async () => {
            const params = {
                title: this.state.radioValue === 'useful' ? "This is useful" : "This isn't useful",
                description: this.state.feedbackValue
            }
            await reqReviewTipsClick(params);
        })
    }

    // 关闭pagefly banner
    closePageflyBanner = () => {
        this.setState({
            isShowPageflyBanner: false,
            isCurrentShow: false,
        }, () => {
            this.requestStateSet(SwitchAll['db_p'])
        })
    }

    // 关闭广告
    closeAdverBox = () => {
        this.setState({
            isShowAdver: false,
        }, () => {
            this.requestStateSet(SwitchAll['db_adver'])
        })
    }

    // 关闭推广banner
    closeAffiliteBanner = () => {
        this.setState({
            isShowAffiliateBanner: false,
        }, () => {
            this.requestStateSet(SwitchAll['db_af'])
        })
    }

    // 跳转外链
    jumpOutUrl = (item) => {
        window.open(item.url);
        this.addClickNums(item.id);
    }

    // 埋点
    addClickNums = async (id) => {
        const params = {
            ad_id: id,
            click_num: 1,
        }
        const res = await reqAddAdsClickNum(params);
        if (res) { }
    }

    // 重新检测谷歌分数
    handleBackRecheck = () => {
        this.setState({
            RecheckButtonLoading: true,
        }, async () => {
            const res = await reqRefreshPageOnline();
            if (res?.ack === 1) {
                this.getPageSpeedOnlineStatus();
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    }
    // 获取状态
    getPageSpeedOnlineStatus = async () => {
        const res = await reqGetPageSpeedOnlineStatus();
        if (res.ack === 1) {
            // 判断是否轮询
            if (res.data?.status !== 1) {
                this.setState({
                    RecheckButtonLoading: true,
                    isResetPageSpeed: true,
                }, () => {
                    if (speedArr.length === 0) {
                        let timer = setInterval(() => {
                            this.getPageSpeedOnlineStatus();
                        }, 10000)
                        speedArr.push(timer);
                    }
                })
            } else {
                this.setState({
                    RecheckButtonLoading: false,
                }, () => {
                    this.clearSpeedArray();
                    // 请求home数据
                    if(this.state.isResetPageSpeed) {
                        this.props.callbackGetHome();
                    }
                })
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 谷歌api请求
    handleRecheckButton = () => {
        this.setState({
            RecheckButtonLoading: true,
        }, async () => {
            const url = "https://" + this.state.TopUrlContent;
            const deskParam = {
                url: url,
                key: PAGESPEED_KEY,
                strategy: "desktop",
                origin: true,
            };
            const deskRes = await reqPageSpeedWebsiteCheck(deskParam)
            if (deskRes?.error) {
                this.props.toggleToast("Try again later", true);
                this.setState({
                    RecheckButtonLoading: true,
                })
            } else {
                this.setState({
                    // TopTotalNumber:70
                })
            }
            const mobileParm = {
                url: url,
                key: PAGESPEED_KEY,
                strategy: "mobile",
                origin: true,
            };
            const mobileRes = await reqPageSpeedWebsiteCheck(mobileParm)
            if (mobileRes?.error) {
                this.props.toggleToast("Try again later", true);
                this.setState({
                    RecheckButtonLoading: true,
                })
            } else {
                this.setState({
                    isDone: true,
                    // TopState:false,
                    TopTotalNumber: 100,
                }, () => {
                    // this.GetPageSpeedOnlineData();
                })
            }
            const deskPageSpeedData = deskRes.lighthouseResult.audits;
            const mobilePageSpeedData = mobileRes.lighthouseResult.audits;
            this.PostPageSpeedOnline(deskPageSpeedData, mobilePageSpeedData);
        });
    }

    //把数据存到后端
    PostPageSpeedOnline = async (deskPageSpeedData, mobilePageSpeedData) => {
        //过滤数据
        let params = {
            "pcAudits": {
                "first-contentful-paint": {
                    "displayValue": deskPageSpeedData['first-contentful-paint'].displayValue,
                    "score": deskPageSpeedData['first-contentful-paint'].score
                },
                "interactive": {
                    "displayValue": deskPageSpeedData['interactive'].displayValue,
                    "score": deskPageSpeedData['interactive'].score,
                },
                "speed-index": {
                    "displayValue": deskPageSpeedData['speed-index'].displayValue,
                    "score": deskPageSpeedData['speed-index'].score,
                },
                "total-blocking-time": {
                    "displayValue": deskPageSpeedData['total-blocking-time'].displayValue,
                    "score": deskPageSpeedData['total-blocking-time'].score,
                },
                "largest-contentful-paint": {
                    "displayValue": deskPageSpeedData['largest-contentful-paint'].displayValue,
                    "score": deskPageSpeedData['largest-contentful-paint'].score,
                },
                "cumulative-layout-shift": {
                    "displayValue": deskPageSpeedData['cumulative-layout-shift'].displayValue,
                    "score": deskPageSpeedData['cumulative-layout-shift'].score,
                },
                "final-screenshot": {
                    "details": {
                        "data": deskPageSpeedData['final-screenshot'].details.data
                    }
                },
                "unused-javascript": {
                    "numericValue": deskPageSpeedData['unused-javascript'].numericValue,
                    "score": deskPageSpeedData['unused-javascript'].score,
                },
                "uses-text-compression": {
                    "numericValue": deskPageSpeedData['uses-text-compression'].numericValue,
                    "score": deskPageSpeedData['uses-text-compression'].score,
                },
                "unused-css-rules": {
                    "numericValue": deskPageSpeedData['unused-css-rules'].numericValue,
                    "score": deskPageSpeedData['unused-css-rules'].score,
                },
                "server-response-time": {
                    "numericValue": deskPageSpeedData['server-response-time'].numericValue,
                    "score": deskPageSpeedData['server-response-time'].score,
                },
                "render-blocking-resources": {
                    "numericValue": deskPageSpeedData['render-blocking-resources'].numericValue,
                    "score": deskPageSpeedData['render-blocking-resources'].score,
                },
                "unminified-javascript": {
                    "numericValue": deskPageSpeedData['unminified-javascript'].numericValue,
                    "score": deskPageSpeedData['unminified-javascript'].score,
                },
                "legacy-javascript": {
                    "numericValue": deskPageSpeedData['legacy-javascript'].numericValue,
                    "score": deskPageSpeedData['legacy-javascript'].score,
                }
            },
            "mobileAudits": {
                "first-contentful-paint": {
                    "displayValue": mobilePageSpeedData['first-contentful-paint'].displayValue,
                    "score": mobilePageSpeedData['first-contentful-paint'].score
                },
                "interactive": {
                    "displayValue": mobilePageSpeedData['interactive'].displayValue,
                    "score": mobilePageSpeedData['interactive'].score,
                },
                "speed-index": {
                    "displayValue": mobilePageSpeedData['speed-index'].displayValue,
                    "score": mobilePageSpeedData['speed-index'].score,
                },
                "total-blocking-time": {
                    "displayValue": mobilePageSpeedData['total-blocking-time'].displayValue,
                    "score": mobilePageSpeedData['total-blocking-time'].score,
                },
                "largest-contentful-paint": {
                    "displayValue": mobilePageSpeedData['largest-contentful-paint'].displayValue,
                    "score": mobilePageSpeedData['largest-contentful-paint'].score,
                },
                "cumulative-layout-shift": {
                    "displayValue": mobilePageSpeedData['cumulative-layout-shift'].displayValue,
                    "score": mobilePageSpeedData['cumulative-layout-shift'].score,
                },
                "final-screenshot": {
                    "details": {
                        "data": mobilePageSpeedData['final-screenshot'].details.data
                    }
                },
                "unused-javascript": {
                    "numericValue": mobilePageSpeedData['unused-javascript'].numericValue,
                    "score": mobilePageSpeedData['unused-javascript'].score,
                },
                "uses-text-compression": {
                    "numericValue": mobilePageSpeedData['uses-text-compression'].numericValue,
                    "score": mobilePageSpeedData['uses-text-compression'].score,
                },
                "unused-css-rules": {
                    "numericValue": mobilePageSpeedData['unused-css-rules'].numericValue,
                    "score": mobilePageSpeedData['unused-css-rules'].score,
                },
                "server-response-time": {
                    "numericValue": mobilePageSpeedData['server-response-time'].numericValue,
                    "score": mobilePageSpeedData['server-response-time'].score,
                },
                "render-blocking-resources": {
                    "numericValue": mobilePageSpeedData['render-blocking-resources'].numericValue,
                    "score": mobilePageSpeedData['render-blocking-resources'].score,
                },
                "unminified-javascript": {
                    "numericValue": mobilePageSpeedData['unminified-javascript'].numericValue,
                    "score": mobilePageSpeedData['unminified-javascript'].score,
                },
                "legacy-javascript": {
                    "numericValue": mobilePageSpeedData['legacy-javascript'].numericValue,
                    "score": mobilePageSpeedData['legacy-javascript'].score,
                }
            }
        };
        let response = await reqPostPageSpeedOnline(params);
        if (response.code === 200) {
            this.GetPageSpeedOnlineData();
            return true;
        }
    }

    //获取数据库数据
    GetPageSpeedOnlineData = async () => {
        this.setState({ polling: true })
        const res = await reqGetSpeedupData();
        this.props.getPageDataRedux({ 'getPageSpeedOnline': res });
        if (res.ack === 1) {
            if (res.data.reports.status === 1) {
                this.setState({
                    RecheckButtonLoading: false,
                }, () => {
                    this.props.toggleToast(t("Success"));
                    if (Boolean(res.data.speed_switch) && res.data.reports.after_opt.m_score === 0 && res.data.reports.after_opt.pc_score === 0) {
                        if (timePage.length === 0) {
                            this.handleRecheckButton();
                            let timer = setInterval(() => {
                                this.GetPageSpeedOnlineData();
                            }, 3000)
                            timePage.push(timer)
                        }
                    } else {
                        this.setState({
                            polling: false,
                        }, () => {
                            // 清除定时器
                            this.clearTimerArray();
                        })
                    }
                    // let _data = cloneDeep(this.props.dashboardData);
                    // let _score = _data.publicInit.seo_data.speed_score;
                    // if(!Boolean(res.data.speed_switch)) {
                    //     _score.mobile.number = res.data.reports.before_opt.m_score;
                    //     _score.desktop.number = res.data.reports.before_opt.pc_score;
                    // } else {
                    //     _score.mobile.number = res.data.reports.after_opt.m_score;
                    //     _score.desktop.number = res.data.reports.after_opt.pc_score;
                    // }
                    let _data = res.data.reports.end_opt;
                    let newScore = {
                        speed_score: {
                            mobile: {
                                number: _data.m_score,
                            },
                            desktop: {
                                number: _data.pc_score,
                            }
                        }
                    }
                    this.setEChartsData(newScore, true, true);
                })
            } else {
                if (timePage.length === 0) {
                    this.handleRecheckButton();
                    let timer = setInterval(() => {
                        this.GetPageSpeedOnlineData();
                    }, 3000)
                    timePage.push(timer)
                }
            }
        } else {
            this.setState({
                isShowErrorBanner: res.msg,
            })
        }
    }

    // 清除定时器
    clearTimerArray = () => {
        timePage.map(timer => {
            clearInterval(timer);
            timePage.pop();
            return false;
        })
    }
    clearSpeedArray = () => {
        speedArr.map(timer => {
            clearInterval(timer);
            speedArr.pop();
            return false;
        })
    }

    //点击联系客服
    handleContactSer = () => {
        try {
            showNewMessage();
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 跳转
    jumpPageUrl = (url) => {
        if (url === 'pending') {
            // 定位待办
            // PendingBox
            this.setState({
                isShowNewFunc: false,
            }, () => {
                let objs = document.getElementById('PendingBox');
                if (objs) {
                    if (objs?.getBoundingClientRect) {
                        window.scrollTo(0, objs.getBoundingClientRect().top - 100, "smooth");
                    }
                    setTimeout(() => {
                        this.setState({
                            isAnimate: true
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    isAnimate: false
                                })
                            }, 1000)
                        })
                    }, 200)
                }
            })
        } else if (url === "NewSEOAntUserGuide") {
            // 打开教学视频
            this.setState({
                isShowNewFunc: false,
            }, () => {
                let objs = document.getElementById('NeedHelpBox');
                if (objs) {
                    if (objs?.getBoundingClientRect) {
                        window.scrollTo(0, objs.getBoundingClientRect().top - 100, "smooth");
                    }
                    setTimeout(() => {
                        this.setState({
                            isVideoAnimate: true
                        }, () => {
                            setTimeout(() => {
                                this.handleHelpBlock('tutorial_video');
                                this.setState({
                                    isVideoAnimate: false
                                })
                            }, 1000)
                        })
                    }, 200)
                }
            })
        } else {
            utils.routeJump(this, url);
        }
    }

    // 更改数据模块伸缩 
    changeQuotaViewState = () => {
        this.setState({
            isShowQuotaPanel: !this.state.isShowQuotaPanel
        })
    }

    // 获取ssoToken
    getCannyPlugInSSO = async () => {
        // try {
        const res = await reqGetCannyPlugInSSO();
        if (res.code === 200) {
            this.setState({
                ssoToken: res.data.ssoToken,
            })
        } else {
            this.setState({
                ssoToken: '',
            }, () => {
                this.props.toggleToast(res.msg, true);
            })
        }
        // } catch (error) {
        // this.props.toggleToast('ssoToken error', true);
        // }
    }

    // 发送反馈
    sendBackStatus = () => {
        this.setState({
            isShowStatus: true
        })
    }

    // 是否全展示feedback
    toggleFeedback = () => {
        this.setState({
            isShowFeedbackAll: !this.state.isShowFeedbackAll,
        })
    }

    // 获取feedback列表
    getFeedbackList = async () => {
        const res = await reqGetFeedback();
        if (res.ack === 1) {
            let richText = res.data.new_functions;
            let parser = new DOMParser();
            let doc = parser.parseFromString(richText, 'text/html');
            let nodeList = doc.body.childNodes;
            let newFuncList = [];
            for (let i = 0; i < nodeList.length; i++) {
                let node = nodeList[i];
                if (node.nodeType === Node.ELEMENT_NODE) {
                    let son = node.childNodes[0];
                    newFuncList[i] = {
                        id: i + 1,
                        title: son.innerText || '',
                        url: son.pathname || '/dashboard',
                        desc: son.title ? son.title.split('==')[0] : '',
                        date: son.title ? son.title.split('==')[1] : '',
                    }
                } else {
                    newFuncList[i] = false;
                }
            }
            this.setState({
                FBLoading: false,
                newFuncList: newFuncList.filter(i => Boolean(i)),
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 打开弹窗
    openNewFuncsModal = () => {
        if (this.state.isShowFuncNums) {
            this.requestStateSet(SwitchAll['db_newfunc'], 1);
        }
        this.setState({
            isShowNewFunc: !this.state.isShowNewFunc,
            isShowFuncNums: false,
        })
    }

    // 打开任务列表
    openTaskPop = () => {
        this.setState({
            isShowTask: !this.state.isShowTask,
        })
    }

    // 打开任务平台
    toggleTaskModal = (type, _state) => {
        this.setState({
            isShowTask: false,
        }, () => {
            this.props.toggleTaskType(type, Boolean(_state));
        })
    }

    // 关闭完成额度
    closeCompleteTip = () => {
        this.setState({
            isShowCompleteTip: false,
        }, () => {
            try {
                sessionStorage.setItem("isShowCompleteTip", "close")
            } catch (e) { }
        })
    }

    // 关闭额度弹窗
    closeImgGetQuota = () => {
        this.setState({
            isShowGetQuota: false,
        }, () => {
            this.requestStateSet(SwitchAll['db_imgquota']);
        })
    }

    // 跳转app
    goSolutionExpert = () => {
        utils.routeJump(this, "/settings", null, { selected: "Solutionexpert", tabkey: 4 });
    }

    // 关闭
    closeAiOnpageBanner = () => {
        this.setState({
            isShowAionpageBanner: false,
        }, () => {
            this.requestStateSet('dashboard_ai_onpage');
        })
    }

    // 跳转onpage -> 生成博客页
    jumpOnpageBlogAi = () => {
        utils.routeJump(this, "/on-page-seo", null, { obj: 'generate-blog' });
    }

    // 获取折扣
    getGuideCouponInfo = () => {
        this.setState({
            couponLoading: true,
        }, async () => {
            const res = await reqGetGuideCoupon();
            if (res.ack === 1) {
                // this.props.toggleToast(res.msg);
                utils.routeJump(this, "/plan");
                // 更新新手引导状态
                let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
                if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
                    data.get_guide_coupon = { "at": Math.floor(new Date().getTime() / 1000), "st": 1 };
                    store.dispatch(setSaveSwitchData(data));
                }
            } else {
                this.props.toggleToast(t("Try again later"), true);
            }

            if (res) {
                this.setState({
                    couponLoading: false,
                })
            }
        })
    }

    // 检查主题扩展状态
    checkThemeStatus = (url) => {
        window.open(url || '');
        this.setState({
            isShowRecheck: true,
        })
    }

    // 检测状态
    checkWebsiteState = async () => {
        let res = await reqCheckWebStatus();
        if (res.ack === 1) {
            this.setState({
                passwordStatus: res.data.is_password !== 0,
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 发送请求
    requestStateSet = async (type, st = 0) => {
        const params = {
            name: `${type}`,
            st: st,
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.dashboardData.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": st, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            this.props.toggleToast(t("Try again later"), true)
        }
    }

    componentWillUnmount() {
        this.clearAppArray();
        this.clearTimerArray();
        this.clearSpeedArray();
        timerArrPage.map(timer => {
            clearInterval(timer);
            timerArrPage.pop();
            return false;
        })

        timerArr.map(timer => {
            clearInterval(timer);
            timerArr.pop();
            return false;
        })
        this.setState = () => false;
    }

    render() {
        const {
            state: {
                // myWebsiteIssues,
                journeyList,
                currentSelected,
                // saveTime,
                saveCost,
                adverList,
                isShowReviewbanner,
                isBeforeShowBanner,
                isStartInx,
                // frequentData,
                isShowAffiliateBanner,
                short_url,
                isShowGuideBox,
                isShowFeedback,
                isShowGuideMain,
                isShowFeedbackBox,
                radioValue,
                feedbackValue,
                // faqUrl,
                // allCount,
                // isShowGoogleWarn,
                googleState,
                // isShowToGoogle,
                isCurrentShow,
                isShowFeedbackRes,
                // uid,
                isShowPageflyBanner,
                adverShowMore,
                isShowAdver,
                isShowGuideOld,
                isCheckLoading,
                pageFlyState,
                AppAdverList,
                adverloading,
                RecheckButtonLoading,
                pendingData,
                isShowQuotaPanel,
                level,
                websiteFuncList,
                optImages,
                repBrokenlinks,
                importantIssues,
                needImprove,
                goodResult,
                scanTime,
                exchangeUse,
                exchangeAll,
                exchangePro,
                onpageUse,
                onpageAll,
                onpagePro,
                imageUse,
                imageAll,
                imagePro,
                isShowNewFunc,
                // isShowFeedbackAll,
                newFuncList,
                FBLoading,
                isShowFuncNums,
                isShowGetQuota,
                isAnimate,
                isAddImageQuota,
                isShowCompleteTip,
                questionList,
                pendSvg,
                openVideo,
                isShowPend,
                isShowWebSpeed,
                isShowAionpageBanner,
                isVideoAnimate,
                isGetGuideCoupon,
                isGetGuideEffect,
                couponLoading,

                showTipModalStatus,
                themeAppExtensionUrl,
                isShowRecheck,
                isShowTask,
                passwordStatus,
            },
            jumpTargetUrl,
            setReview,
            mouseEnterReview,
            mouseLeaveReview,
            copyAfUrl,
            openAppAction,
            handleDismiss,
            openGiveFeedbackBox,
            closeFinishFeedback,
            changeGuideSet,
            handleGuideMain,
            handleRadioChange,
            handleFeedbackChange,
            openGuideItem,
            changeFinishState,


        } = this;
        
        // 扩展banner
        const embedBanner = showTipModalStatus && <Banner
            tone="warning"
            title={t("Enable Shopify app embed")}
            onDismiss={() => {
                this.setState({ showTipModalStatus: false })
            }}
        >
            <BlockStack gap={200}>
                <p>{t("Some important functions require the SEOAnt extension to be installed before they can be used.")}</p>
                <div className='flex_layout'>
                    <Button onClick={() => this.checkThemeStatus(themeAppExtensionUrl)}>{t("Enable app embed")}</Button>
                    {
                        isShowRecheck && <Button variant='plain' onClick={this.checkThemeExtension} loading={isCheckLoading}>{t("Recheck")}</Button>
                    }
                </div>
            </BlockStack>
        </Banner>

        // Ai onpage
        const AiOnpageBanner = isShowAionpageBanner && <div className='ai-onpage-banner' onClick={this.jumpOnpageBlogAi} style={{ minHeight: '168px' }}>
            <img src='/banner/ai-onpage.png' alt='' />
            <span className='close-icon' onClick={(e) => {
                e.stopPropagation();
                this.closeAiOnpageBanner();
            }}><Icon source={CancelMinor} /></span>
        </div>

        // pageFly banner
        const reAppBanner = (isShowPageflyBanner && AppAdverList.length > 0) && <div className='pagefly_banner'>
            {
                AppAdverList.map((item, index) => {
                    return <div key={item.id} style={{ display: pageFlyState - 1 === index ? 'block' : 'none' }}>
                        <Banner
                            title={t(item.title)}
                            tone="info"
                            onDismiss={this.closePageflyBanner}
                        >
                            <p style={{ marginBottom: '0.3rem' }}>{t(item.desc)}</p>
                            <Button size='slim' onClick={() => this.jumpOutUrl(item)}>{t(item.btn)}</Button>
                        </Banner>
                    </div>
                })

            }
        </div>

        // 好评banner 
        const reviewBanner = (isShowReviewbanner && isBeforeShowBanner && !isShowPageflyBanner) && <div>
            <Banner
                title={t("We want to provide the best experience for you")}
                tone="info"
                onDismiss={() => setReview(0)}
            >
                <div className='flex_layout' style={{ columnGap: '1em' }}>
                    {t("Your feedback means a lot to us! Take a minute to leave your review.")}
                    <div className='start_review'>
                        <div className={`start_review_item ${[1, 2, 3, 4, 5].includes(isStartInx) && 'isReviewHigh'}`} onMouseEnter={() => mouseEnterReview(1)} onMouseLeave={() => mouseLeaveReview(1)} onClick={() => setReview(1)}><Icon source={StarIcon} /></div>
                        <div className={`start_review_item ${[2, 3, 4, 5].includes(isStartInx) && 'isReviewHigh'}`} onMouseEnter={() => mouseEnterReview(2)} onMouseLeave={() => mouseLeaveReview(2)} onClick={() => setReview(2)}><Icon source={StarIcon} /></div>
                        <div className={`start_review_item ${[3, 4, 5].includes(isStartInx) && 'isReviewHigh'}`} onMouseEnter={() => mouseEnterReview(3)} onMouseLeave={() => mouseLeaveReview(3)} onClick={() => setReview(3)}><Icon source={StarIcon} /></div>
                        <div className={`start_review_item ${[4, 5].includes(isStartInx) && 'isReviewHigh'}`} onMouseEnter={() => mouseEnterReview(4)} onMouseLeave={() => mouseLeaveReview(4)} onClick={() => setReview(4)}><Icon source={StarIcon} /></div>
                        <div className={`start_review_item ${[5].includes(isStartInx) && 'isReviewHigh'}`} onMouseEnter={() => mouseEnterReview(5)} onMouseLeave={() => mouseLeaveReview(5)} onClick={() => setReview(5)}><Icon source={StarIcon} /></div>
                    </div>
                </div>
            </Banner>
        </div>

        // Affiliate入口
        // email
        const emailIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M2.66663 7.33331C2.66663 5.27145 4.3381 3.59998 6.39996 3.59998H17.6C19.6618 3.59998 21.3333 5.27145 21.3333 7.33331V16.6666C21.3333 18.7285 19.6618 20.4 17.6 20.4H6.39996C4.3381 20.4 2.66663 18.7285 2.66663 16.6666V7.33331Z" fill="#564FEA" />
            <path d="M17.6 3.59998H6.39996C4.3381 3.59998 2.66663 5.27145 2.66663 7.33331L9.66776 12.9342C11.0312 14.025 12.9687 14.025 14.3322 12.9342L21.3333 7.33331C21.3333 5.27145 19.6618 3.59998 17.6 3.59998Z" fill="#564FEA" />
        </svg>
        // facebook
        const facebook = <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.04 3.59998H6.95993C5.10425 3.59998 3.59991 5.10431 3.59991 6.96V17.0401C3.59991 18.8957 5.10425 20.4001 6.95993 20.4001H17.04C18.8957 20.4001 20.4 18.8957 20.4 17.0401V6.96C20.4 5.10431 18.8957 3.59998 17.04 3.59998Z" fill="#0079FC" />
            <path d="M16.2 7.79987H14.1C12.2443 7.79987 10.7399 9.3042 10.7399 11.1599V12.8399H7.79993V15.3599H10.7399V20.3999H13.26V15.3599H16.2V12.8399H13.26V11.1599C13.26 10.696 13.636 10.3199 14.1 10.3199H16.2V7.79987Z" fill="white" />
        </svg>

        const AffiliateBanner = ((Boolean(short_url) && isShowAffiliateBanner) && !(isShowReviewbanner && isBeforeShowBanner) && isCurrentShow && !isShowPageflyBanner) && <div className="Affiliate_program">
            <Banner
                icon={ReferralMajor}
                title={<span style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontWeight: 400 }}>{t("Offer your friends a 30% discount and earn a 30% commission for SEOAnt by sharing this link") + ' : '}</span>
                    <span style={{ fontWeight: 400 }}>{t("The referral store has never installed SEOAnt APP before.")}</span>
                </span>}
                tone="info"
                onDismiss={() => this.closeAffiliteBanner()}
            >
                <div className='af_url'>
                    <a href={`${short_url}`} target='_blank' rel="noopener noreferrer">{short_url}</a>
                    <div onClick={copyAfUrl}><Icon source={DuplicateMinor}></Icon></div>
                </div>
                <div className='af_action'>
                    <a className='email' href={"mailto:?subject=I think you'll like SEOAnt - SEO %26 Image Optimizer 😘&body=    I wanted to share with you a great tool that has helped me optimize my store's SEO - SEOAnt. This app has been a game changer for me as it has saved me time and improved my site's rankings through bulk optimization of meta tags, images, and automatic redirection of broken links. With SEOAnt, I can focus on creating great content, and its AI Writing feature has even given me ideas for content creation that have increased my traffic.%0d%0a    I highly recommend giving SEOAnt a try. If you use the following link, you can even get 30% discount for all plan: " + this.state.short_url + "%0d%0a    Thank you and regards."} target="_top">{emailIcon}</a>
                    <div className='facebook' onClick={() => openAppAction('facebook')}>{facebook}</div>
                </div>
            </Banner>
        </div>

        // 新手引导
        const cirIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="_hUo3"><path fillRule="evenodd" clipRule="evenodd" d="M21.9147 13.3062L19.9315 13.0475C19.9761 12.7056 19.9993 12.3561 19.9993 12.0001C19.9993 11.6442 19.9761 11.2946 19.9315 10.9527L21.9147 10.694C21.9705 11.1215 21.9993 11.5575 21.9993 12.0001C21.9993 12.4428 21.9705 12.8787 21.9147 13.3062ZM21.2405 8.17224L19.393 8.93835C19.1238 8.28906 18.7709 7.68206 18.3474 7.13093L19.9333 5.91228C20.4621 6.6004 20.9033 7.35927 21.2405 8.17224ZM18.0871 4.06613L16.8685 5.65197C16.3173 5.22845 15.7103 4.87563 15.061 4.60638L15.8271 2.75893C16.6401 3.09605 17.399 3.53734 18.0871 4.06613ZM13.3054 2.08464L13.0467 4.06784C12.7048 4.02324 12.3552 4.00012 11.9993 4.00012C11.6433 4.00012 11.2938 4.02324 10.9519 4.06784L10.6932 2.08464C11.1206 2.02889 11.5566 2.00012 11.9993 2.00012C12.4419 2.00012 12.8779 2.02889 13.3054 2.08464ZM8.17139 2.75893L8.9375 4.60638C8.2882 4.87563 7.6812 5.22845 7.13008 5.65197L5.91143 4.06613C6.59954 3.53734 7.35841 3.09606 8.17139 2.75893ZM4.06527 5.91228L5.65111 7.13093C5.22759 7.68206 4.87478 8.28906 4.60552 8.93835L2.75807 8.17225C3.0952 7.35927 3.53648 6.6004 4.06527 5.91228ZM2.08379 10.694C2.02803 11.1215 1.99927 11.5575 1.99927 12.0001C1.99927 12.4428 2.02803 12.8787 2.08379 13.3062L4.06699 13.0475C4.02239 12.7056 3.99927 12.3561 3.99927 12.0001C3.99927 11.6442 4.02239 11.2946 4.06699 10.9527L2.08379 10.694ZM2.75807 15.828L4.60553 15.0619C4.87478 15.7112 5.22759 16.3182 5.65111 16.8693L4.06527 18.088C3.53648 17.3998 3.0952 16.641 2.75807 15.828ZM5.91143 19.9341L7.13008 18.3483C7.68121 18.7718 8.28821 19.1246 8.9375 19.3939L8.17139 21.2413C7.35841 20.9042 6.59955 20.4629 5.91143 19.9341ZM10.6932 21.9156L10.9519 19.9324C11.2938 19.977 11.6433 20.0001 11.9993 20.0001C12.3552 20.0001 12.7048 19.977 13.0467 19.9324L13.3054 21.9156C12.8779 21.9714 12.4419 22.0001 11.9993 22.0001C11.5566 22.0001 11.1206 21.9714 10.6932 21.9156ZM15.8271 21.2413L15.061 19.3939C15.7103 19.1246 16.3173 18.7718 16.8685 18.3483L18.0871 19.9341C17.399 20.4629 16.6401 20.9042 15.8271 21.2413ZM19.9333 18.088L18.3474 16.8693C18.7709 16.3182 19.1238 15.7112 19.393 15.0619L21.2405 15.828C20.9033 16.641 20.4621 17.3998 19.9333 18.088Z" fill="#8C9196" className="Pklnb WzwlI"></path><path fillRule="evenodd" clipRule="evenodd" d="M10.5334 2.10692C11.0126 2.03643 11.5024 2 12 2C12.4976 2 12.9874 2.03643 13.4666 2.10692C14.013 2.18729 14.3908 2.6954 14.3104 3.2418C14.23 3.78821 13.7219 4.166 13.1755 4.08563C12.7924 4.02927 12.3999 4 12 4C11.6001 4 11.2076 4.02927 10.8245 4.08563C10.2781 4.166 9.76995 3.78821 9.68958 3.2418C9.6092 2.6954 9.987 2.18729 10.5334 2.10692ZM7.44122 4.17428C7.77056 4.61763 7.67814 5.24401 7.23479 5.57335C6.603 6.04267 6.04267 6.603 5.57335 7.23479C5.24401 7.67814 4.61763 7.77056 4.17428 7.44122C3.73094 7.11188 3.63852 6.4855 3.96785 6.04216C4.55386 5.25329 5.25329 4.55386 6.04216 3.96785C6.4855 3.63852 7.11188 3.73094 7.44122 4.17428ZM16.5588 4.17428C16.8881 3.73094 17.5145 3.63852 17.9578 3.96785C18.7467 4.55386 19.4461 5.25329 20.0321 6.04216C20.3615 6.4855 20.2691 7.11188 19.8257 7.44122C19.3824 7.77056 18.756 7.67814 18.4267 7.23479C17.9573 6.603 17.397 6.04267 16.7652 5.57335C16.3219 5.24401 16.2294 4.61763 16.5588 4.17428ZM3.2418 9.68958C3.78821 9.76995 4.166 10.2781 4.08563 10.8245C4.02927 11.2076 4 11.6001 4 12C4 12.3999 4.02927 12.7924 4.08563 13.1755C4.166 13.7219 3.78821 14.23 3.2418 14.3104C2.6954 14.3908 2.18729 14.013 2.10692 13.4666C2.03643 12.9874 2 12.4976 2 12C2 11.5024 2.03643 11.0126 2.10692 10.5334C2.18729 9.987 2.6954 9.6092 3.2418 9.68958ZM20.7582 9.68958C21.3046 9.6092 21.8127 9.987 21.8931 10.5334C21.9636 11.0126 22 11.5024 22 12C22 12.4976 21.9636 12.9874 21.8931 13.4666C21.8127 14.013 21.3046 14.3908 20.7582 14.3104C20.2118 14.23 19.834 13.7219 19.9144 13.1755C19.9707 12.7924 20 12.3999 20 12C20 11.6001 19.9707 11.2076 19.9144 10.8245C19.834 10.2781 20.2118 9.76995 20.7582 9.68958ZM4.17428 16.5588C4.61763 16.2294 5.24401 16.3219 5.57335 16.7652C6.04267 17.397 6.603 17.9573 7.23479 18.4267C7.67814 18.756 7.77056 19.3824 7.44122 19.8257C7.11188 20.2691 6.4855 20.3615 6.04216 20.0321C5.25329 19.4461 4.55386 18.7467 3.96785 17.9578C3.63852 17.5145 3.73094 16.8881 4.17428 16.5588ZM19.8257 16.5588C20.2691 16.8881 20.3615 17.5145 20.0321 17.9578C19.4461 18.7467 18.7467 19.4461 17.9578 20.0321C17.5145 20.3615 16.8881 20.2691 16.5588 19.8257C16.2294 19.3824 16.3219 18.756 16.7652 18.4267C17.397 17.9573 17.9573 17.397 18.4267 16.7652C18.756 16.3219 19.3824 16.2294 19.8257 16.5588ZM9.68958 20.7582C9.76995 20.2118 10.2781 19.834 10.8245 19.9144C11.2076 19.9707 11.6001 20 12 20C12.3999 20 12.7924 19.9707 13.1755 19.9144C13.7219 19.834 14.23 20.2118 14.3104 20.7582C14.3908 21.3046 14.013 21.8127 13.4666 21.8931C12.9874 21.9636 12.4976 22 12 22C11.5024 22 11.0126 21.9636 10.5334 21.8931C9.987 21.8127 9.6092 21.3046 9.68958 20.7582Z" fill="#8A8A8A" className="CLJ7G WzwlI"></path><circle cx="12" cy="12" r="12" fill="#DBDDDF" className="Pklnb hKH6r"></circle><circle cx="12" cy="12" r="9" fill="#F6F6F7" stroke="#999EA4" strokeWidth="2" className="hKH6r"></circle></svg>;
        const finishIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="DdVKM"><circle cx="12" cy="12" r="10" fill="#000"></circle><path d="M17.2738 8.52629C17.6643 8.91682 17.6643 9.54998 17.2738 9.94051L11.4405 15.7738C11.05 16.1644 10.4168 16.1644 10.0263 15.7738L7.3596 13.1072C6.96908 12.7166 6.96908 12.0835 7.3596 11.693C7.75013 11.3024 8.38329 11.3024 8.77382 11.693L10.7334 13.6525L15.8596 8.52629C16.2501 8.13577 16.8833 8.13577 17.2738 8.52629Z" fill="#fff"></path></svg>
        // const progressGuide = isShowGuideOld ? Object.keys(journeyList).filter(i => i !== "EmBed" && Boolean(journeyList[i]['status'])).length : Object.keys(journeyList).filter(i => i !== "SEOChecker" && Boolean(journeyList[i]['status'])).length;
        // const comp = isShowGuideOld ? ((progressGuide || 1) - 1) : progressGuide;
        // const allp = isShowGuideOld ? (Object.keys(journeyList).length) - 1 : (Object.keys(journeyList).length);
        const progressGuide = Object.keys(journeyList).filter(i => Boolean(journeyList[i]['status'])).length;
        const comp = progressGuide;
        const allp = Object.keys(journeyList).length;
        const UserGuide = isShowGuideBox ? !isShowFeedbackRes ? !isShowFeedbackBox ? <Card>
            <BlockStack gap={200}>
                <div className='guide_top'>
                    <BlockStack>
                        <Text variant="headingMd" as="h2">{t("Get started")}</Text>
                        <div>
                            <Text as="p" tone="subdued">{t("Follow the steps below to set your store for SEO success.")}</Text>
                        </div>
                    </BlockStack>
                    <div className='guide_opera'>
                        <Popover
                            active={isShowFeedback}
                            activator={<div onClick={changeGuideSet}><Icon color='base' source={MobileHorizontalDotsMajor} /></div>}
                            onClose={changeGuideSet}
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: t("Dismiss"),
                                        onAction: () => handleDismiss(SwitchAll['db_ug']),
                                        icon: CancelMajor
                                    },
                                    {
                                        content: t("Give feedback"),
                                        onAction: openGiveFeedbackBox,
                                        icon: ChatMajor
                                    },
                                ]}
                            />
                        </Popover>
                        <div onClick={handleGuideMain}><Icon color='base' source={isShowGuideMain ? ChevronDownMinor : ChevronUpMinor} /></div>
                    </div>
                </div>
                {
                    (isShowCompleteTip && isGetGuideCoupon && level === 1) &&
                    <div className='flex_layout guide_discount_tip'>
                        {
                            !isShowGetQuota ? <>
                                <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 0L11.6279 2.65572L15.364 2.63604L15.3443 6.37211L18 9L15.3443 11.6279L15.364 15.364L11.6279 15.3443L9 18L6.37211 15.3443L2.63604 15.364L2.65572 11.6279L0 9L2.65572 6.37211L2.63604 2.63604L6.37211 2.65572L9 0Z" fill="#7126EF" />
                                    <path d="M8.92405 13.9993C8.20663 13.9993 7.549 13.833 6.95115 13.5005C6.35331 13.168 5.87865 12.7035 5.52719 12.1072C5.17573 11.5108 5 10.8403 5 10.0958C5 9.35123 5.17573 8.68257 5.52719 8.08982C5.87865 7.49707 6.35331 7.03443 6.95115 6.70191C7.549 6.36939 8.20663 6.20312 8.92405 6.20312C9.64147 6.20312 10.2991 6.36939 10.8969 6.70191C11.4948 7.03443 11.9658 7.49707 12.31 8.08982C12.6543 8.68257 12.8264 9.35123 12.8264 10.0958C12.8264 10.8403 12.6524 11.5108 12.3046 12.1072C11.9568 12.7035 11.4857 13.168 10.8915 13.5005C10.2973 13.833 9.64147 13.9993 8.92405 13.9993ZM8.92505 12.7143C9.64563 12.7143 10.2225 12.4747 10.6557 11.9955C11.0889 11.5163 11.3055 10.883 11.3055 10.0958C11.3055 9.29998 11.0889 8.66462 10.6557 8.1897C10.2225 7.71478 9.64563 7.47732 8.92505 7.47732C8.19589 7.47732 7.61471 7.71264 7.18151 8.18328C6.74831 8.65392 6.5317 9.29142 6.5317 10.0958C6.5317 10.8916 6.74831 11.527 7.18151 12.0019C7.61471 12.4768 8.19589 12.7143 8.92505 12.7143Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.5847 4.52117C6.63401 4.21305 6.87189 3.9803 7.11602 4.00132C7.36016 4.02234 7.51809 4.28916 7.46878 4.59728C7.43474 4.81002 7.3108 4.98683 7.15697 5.06899C7.20188 5.30162 7.29893 5.55481 7.44812 5.82856C7.66636 6.22903 7.97667 6.65026 8.37906 7.09226L8.05986 7.18719C7.68625 6.81154 7.39808 6.43104 7.19538 6.04569C7.04243 5.75491 6.94194 5.44322 6.89391 5.11061C6.67489 5.06352 6.53839 4.81056 6.5847 4.52117Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.2437 4.52117C11.1944 4.21305 10.9565 3.9803 10.7123 4.00132C10.4682 4.02234 10.3103 4.28916 10.3596 4.59728C10.3936 4.81002 10.5176 4.98683 10.6714 5.06899C10.6265 5.30162 10.5294 5.55481 10.3803 5.82856C10.162 6.22903 9.8517 6.65026 9.44931 7.09226L9.76851 7.18719C10.1421 6.81154 10.4303 6.43104 10.633 6.04569C10.7859 5.75491 10.8864 5.44322 10.9345 5.11061C11.1535 5.06352 11.29 4.81056 11.2437 4.52117Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.14643 9.34054C7.87624 9.6109 7.87624 10.0493 8.14643 10.3196C8.41662 10.59 8.85469 10.59 9.12489 10.3196C9.39508 10.0493 9.39508 9.6109 9.12489 9.34054C8.85469 9.07017 8.41662 9.07017 8.14643 9.34054ZM7.83553 10.6307C7.39363 10.1885 7.39363 9.47162 7.83553 9.02944C8.27743 8.58726 8.99389 8.58726 9.43579 9.02944C9.87769 9.47162 9.87769 10.1885 9.43579 10.6307C8.99389 11.0729 8.27743 11.0729 7.83553 10.6307Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9.17108 10.3353C9.25994 10.2526 9.39904 10.2575 9.48177 10.3464L10.1599 11.0753C10.2427 11.1643 10.2377 11.3035 10.1488 11.3862C10.06 11.469 9.92087 11.4641 9.83814 11.3751L9.15998 10.6463C9.07725 10.5573 9.08222 10.4181 9.17108 10.3353Z" fill="white" />
                                </svg>
                                <p>{t("Complete this guide and you'll get")}&nbsp;<span style={{ color: '#7126ef' }}>{t("{{v1}} OFF", `${40}%`)}</span>&nbsp;{t("for all plans!")}</p>
                            </> : <>
                                🎉 <p className='congra_info flex_layout'>{t("Congratulations! You've received a")}&nbsp;<span style={{ color: '#7126ef' }}>{t("{{v1}} OFF", `${40}%`)}</span>.&nbsp;
                                    {
                                        couponLoading ? <Spinner size='small' /> : !isGetGuideEffect && <span className='click_claim' onClick={this.getGuideCouponInfo}>{t("Click to claim it!")}</span>
                                    }
                                </p>
                            </>
                        }
                        <span className='guide_dis_close' onClick={this.closeCompleteTip}><Icon source={CancelMajor} /></span>
                    </div>
                }
                <div className='guide_progress'>
                    <Text as="p" color="subdued">{t("{{v1}} of {{v2}} tasks completed", comp, allp)}</Text>
                    <ProgressBar tone='primary' progress={(100 / allp) * comp} size="small" />
                </div>
                {/* <div className='card_line_row'></div> */}
            </BlockStack>
            <Collapsible
                id={`guide-main-collapsible`}
                open={!isShowGuideMain}
                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                expandOnPrint
            >
                <div className='guide_content'>
                    <Layout>
                        {/* <Layout.Section variant='oneThird'>
                            <div className='video_box'><img src='/Image/videoImage.png' alt='videoImage.png' /></div>
                        </Layout.Section> */}
                        <Layout.Section>
                            {
                                Object.keys(journeyList).map(item => {
                                    return isShowGuideOld && item === 'EmBed' ? null : !isShowGuideOld && item === 'SEOChecker' ? null : <div key={item} onClick={() => openGuideItem(journeyList[item]['id'])} className={`gItem ${currentSelected === journeyList[item]['id'] ? 'gActive' : ''}`}>
                                        <div className='circle_point' onClick={(e) => changeFinishState(e, journeyList[item])}>
                                            {!Boolean(journeyList[item]?.status) ? cirIcon : finishIcon}
                                        </div>
                                        <div className='guide_middle_content'>
                                            <BlockStack gap={200}>
                                                <div className='gItem_title'>
                                                    {
                                                        currentSelected === journeyList[item].id ?
                                                            <Text variant="headingMd" as="h6">{t(journeyList[item].tag)}</Text> :
                                                            <Text as="p" fontWeight="regular">{t(journeyList[item].tag)}</Text>
                                                    }
                                                </div>
                                                <Collapsible
                                                    open={currentSelected === journeyList[item].id}
                                                    id={`${item}-collapsible`}
                                                    transition={{ duration: '300ms', timingFunction: 'var(--p-motion-ease-in-out)' }}
                                                    expandOnPrint
                                                >
                                                    <div className='guide_col_main flex_layout'>
                                                        <div className='gItemContent'>
                                                            <BlockStack gap={400}>
                                                                <Text as="p" color="subdued">{t(journeyList[item].desc)}</Text>
                                                                {
                                                                    journeyList[item].title !== "EmBed" ?
                                                                        <div><Button onClick={() => this.jumpToPage(journeyList[item].url, 'tip')} variant='primary' size='slim'>{t(journeyList[item].btn)}</Button></div>
                                                                        :
                                                                        <div>
                                                                            <Button onClick={() => {
                                                                                window.open(journeyList[item].url)
                                                                            }} variant='primary' size='slim'>{t(journeyList[item].btn)}</Button>
                                                                            &nbsp;&nbsp;&nbsp;
                                                                            {!Boolean(journeyList[item].status) ? <Button variant='plain' loading={isCheckLoading} onClick={this.checkThemeExtension}>{t("Recheck")}</Button> : null}
                                                                        </div>
                                                                }
                                                                {/* <div className='gTip'>
                                                                    <Text as="p" color="subdued">{t("Don't know how to do this? Please follow")}</Text>&nbsp;
                                                                    <Button onClick={() => this.jumpToPage(faqUrl)} variant='plain' textAlign="left">{t("this instruction.")}</Button>
                                                                </div> */}
                                                            </BlockStack>
                                                        </div>
                                                    </div>
                                                </Collapsible>
                                            </BlockStack>
                                        </div>
                                        <div className={`guide_img ${currentSelected === journeyList[item].id ? 'guide_show_img' : ''}`}><img src={`${journeyList[item].img}?v=12305`} alt='' /></div>
                                    </div>
                                })
                            }
                        </Layout.Section>
                    </Layout>
                </div>
            </Collapsible>
        </Card> : <div className='feedbackBox'>
            <Card>
                <BlockStack gap={400}>
                    <Text variant="headingMd" as="h2">{t("Send feedback")}</Text>
                    <BlockStack gap={200}>
                        <RadioButton
                            label={t("This is useful")}
                            checked={radioValue === 'useful'}
                            id="useful"
                            name="useful"
                            onChange={handleRadioChange}
                        />
                        <RadioButton
                            label={t("This isn't useful")}
                            id="notuseful"
                            name="notuseful"
                            checked={radioValue === 'notuseful'}
                            onChange={handleRadioChange}
                        />
                    </BlockStack>
                    <TextField
                        value={feedbackValue}
                        onChange={handleFeedbackChange}
                        multiline={4}
                        autoComplete="off"
                        placeholder='Additional comments'
                    />
                    <div className='guide_btn_opera'>
                        <Button onClick={() => this.sendFeedbackData()} size="slim" disabled={!Boolean(feedbackValue) || Number(feedbackValue) === 0}>{t("Send feedback")}</Button>
                        <Button variant='plain' textAlign="left" onClick={openGiveFeedbackBox}>{t("Cancel")}</Button>
                    </div>
                </BlockStack>
            </Card>
        </div> : <Card>
            <div className='close_guide_feedtip' onClick={closeFinishFeedback}>
                <Icon source={CancelSmallMinor} color='base' />
            </div>
            <Text variant="headingMd" as="h6">{t("Thanks for your feedback")}</Text>
            <Text as="p" color="subdued">{t("It will be used to improve your seo feed.")}</Text>
        </Card> : null;

        // 额度弹窗
        // const quotaImgModal = <Modal
        //     open={isShowGetQuota}
        //     title={t("Complete the Beginner's Guide")}
        //     primaryAction={{
        //         content: t("OK"),
        //         onAction: this.closeImgGetQuota,
        //     }}
        //     onClose={this.closeImgGetQuota}
        // >
        //     <div className='get_img_quota'>
        //         <p>{t("Congratulations on completing the Beginner's Guide! Your image compression limit has been increased!")}</p>
        //         <div className='get_img_progress flex_layout'>
        //             <p>{t("Image Quota")}: <span>{imageUse}/{imageAll}</span></p>
        //         </div>
        //     </div>
        // </Modal>

        // Pending 列表
        const pendindList = isShowPend && <Card>
            <Text variant="headingMd" as="h2">{t("Pending")}</Text>
            <div id='PendingBox' style={{ width: '100%', height: '1px' }}></div>
            <div className='pending_list'>
                {
                    (pendingData.filter(i => i.num > 0)).length > 0 ? pendingData.map((item, index) => {
                        return (item.num > 0 ? <div key={item.id} className={`pend_item flex_layout ${isAnimate ? 'pending_item' : ''}`} onClick={() => this.jumpPageUrl(item.url)}>
                            <div className='flex_layout' key={`child-${Number(item.id)}-${index}`}>
                                {pendSvg[item.id]}
                                <span>{item.num}</span>{t(item.desc)}
                            </div>
                            <div className='right-icon'><Icon source={ChevronRightMinor} /></div>
                        </div> : null)
                    }) : <div className='pend_empty' >
                        <p>{t("No pending tasks, keep it up!")}</p>
                        <svg t="1713756501801" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9496" width="20" height="20"><path d="M648.743382 404.237493c121.111302 123.798399 170.182811 274.361137 109.637824 336.270999l-2.473836 2.38853-2.921685 2.516488-3.369534 2.665771-3.83871 2.83638-4.265233 2.964337-4.713083 3.113621-5.182259 3.262903-5.608782 3.412187-9.255556 5.39552-6.739069 3.774732-10.96165 5.95-11.942653 6.269893-12.966309 6.611112-9.191578 4.585126-14.651077 7.144266-26.657709 12.667743-17.316847 8.061291-31.136204 14.139248-41.052871 18.169895-45.083517 19.513442-40.647674 17.274195-43.441401 18.191221-46.277783 19.108245-69.437999 28.32115-52.974198 21.326167-102.856103 40.796957a38.173839 38.173839 0 0 1-41.415416-8.914338l-37.83262-38.66434a40.263803 40.263803 0 0 1-8.743728-42.332442l26.998927-71.293375 37.875272-98.505565 23.629393-60.523662 25.911293-65.386027 24.162547-59.798572 19.300181-46.768284 15.098926-35.82796 14.181901-32.970254 10.705736-24.31183 10.129929-22.47778 7.22957-15.674733 9.106274-19.257529 6.461828-13.264875 6.141936-12.219894 5.822044-11.174911 7.250897-13.328855 3.412186-5.971326 4.84104-8.103944 3.028316-4.819713 2.921685-4.350539 2.751075-3.924014 2.623119-3.454839 2.452509-2.985664 2.345878-2.537813c60.566314-61.909862 207.823496-11.729392 328.934798 112.111659z" fill="#CF411C" p-id="9497"></path><path d="M634.945352 418.035523c-112.602161-115.097323-246.445184-161.993563-298.353074-115.012018l-2.55914 2.473835-1.663441 1.748746-1.962008 2.345878-2.217921 2.921685-2.452509 3.454839-2.665771 3.987993-2.772402 4.414517-4.649104 7.741398-3.220251 5.630108-7.080288 12.987636-5.67276 10.940324-6.035305 12.027958-6.376524 13.030288-9.042295 19.086919-7.144266 15.504123-10.065951 22.328497-10.620431 24.162547-14.139248 32.842297-15.034948 35.678677-19.257529 46.640327-24.098568 59.670615-25.889967 65.300723-23.58674 60.438357-37.83262 98.42026-26.998928 71.272049a20.537099 20.537099 0 0 0 2.72975 19.534769l1.706093 1.983334 37.811294 38.643014c4.798388 4.926345 11.686739 6.824373 18.127242 5.224911l2.409857-0.767742 102.749472-40.775631 52.888893-21.283515 69.395347-28.278497 46.171152-19.065593 43.356097-18.148568 40.519717-17.231543 44.934233-19.449464 40.882262-18.105916 30.986921-14.07527 17.167564-7.975986 26.465773-12.582439 14.501793-7.080287 9.063621-4.499821 12.753048-6.504481 11.708066-6.141936 10.705735-5.822044 6.483155-3.625448 8.95699-5.203585 5.331542-3.241577 4.819714-3.049642 4.350538-2.857706 3.817384-2.644445 3.305555-2.409857 2.72975-2.153943 2.175269-1.83405 2.025986-1.940681c50.543015-51.673302 4.947671-191.530305-109.637824-308.674939z" fill="#F66E2E" p-id="9498"></path><path d="M336.592278 303.023505c51.90789-46.981546 185.750913-0.085305 298.353074 115.012018 81.636567 83.470617 128.255567 178.457364 130.046965 244.867047l-1.10896 1.023656-2.175269 1.834051-2.72975 2.153943-3.305556 2.431183-3.83871 2.644444-4.329211 2.857707-4.84104 3.049642-5.331542 3.220251-8.95699 5.203584-6.461829 3.625449-10.705735 5.822043-11.729392 6.141936-12.731722 6.504481-9.063621 4.521148-14.501793 7.080287-26.444447 12.582439-17.188891 7.975986-30.98692 14.07527-40.882262 18.105916-44.934233 19.449464-40.519717 17.210217-43.356098 18.148568-46.171151 19.086919-69.374021 28.257171-52.888893 21.304841-102.792125 40.775631-69.864522 31.605379-9.810037-10.023298-1.684767-1.962008a20.515773 20.515773 0 0 1-3.497492-17.018281l0.767742-2.516488 26.998928-71.272049 37.83262-98.42026 23.58674-60.438357 25.889967-65.300723 24.098568-59.670615 19.257529-46.640327 15.034948-35.700003 14.139248-32.820971 10.620431-24.162547 10.065951-22.328497 7.144266-15.504123 9.042295-19.086919 6.376524-13.030288 6.035305-12.027958 5.67276-10.940324 7.080288-12.987636 3.198925-5.630108 4.649104-7.741398 2.793728-4.414517 2.665771-3.987993 2.452509-3.454839 2.217921-2.921685 1.962008-2.345878 1.642114-1.748746 2.55914-2.473835z" fill="#FD9816" p-id="9499"></path><path d="M391.933681 285.258808h-2.836381c-22.008604 0.426523-39.66667 6.419176-52.078499 17.380826l-2.985663 2.857706-1.663441 1.748746-1.962008 2.345878-2.217921 2.921685-2.452509 3.454839-2.665771 3.987993-2.772402 4.414517-4.649104 7.741398-3.220251 5.630108-7.080288 12.987636-5.67276 10.940324-6.035305 12.027958-6.376524 13.030288-9.042295 19.086919-7.144266 15.504123-10.065951 22.328497-10.620431 24.162547-14.608424 33.929932 1.535484 9.212904a1018.687012 1018.687012 0 0 0 144.143562 373.805052l7.720072 11.96398 8.359858-3.433513 43.356097-18.148568 10.129929-4.329212-2.985663-7.592115c-70.696243-181.48568-90.29499-380.181576-57.090149-572.436971l0.981004-5.544803zM161.675057 683.418343l-9.703406 24.525092-24.077242 61.696601 3.28423 9.490144a1013.35547 1013.35547 0 0 0 79.397319 170.737292l9.340861 15.696058 9.170252-3.625448 38.579035-15.568102L263.123633 938.351342A1056.519632 1056.519632 0 0 1 166.302835 701.119061l-4.649104-17.700718z" fill="#FFD217" p-id="9500"></path><path d="M319.808584 292.125834c60.566314-61.909862 207.823496-11.729392 328.934798 112.111659 121.111302 123.798399 170.182811 274.361137 109.637824 336.270999-60.566314 61.909862-207.823496 11.729392-328.934798-112.090333-121.132628-123.819725-170.204138-274.382463-109.637824-336.292325z" fill="#CF411C" p-id="9501"></path><path d="M634.945352 418.035523c-114.50019-117.05933-251.008984-163.5717-301.338738-112.090333-50.543015 51.651976-4.947671 191.508978 109.616498 308.653613 114.521516 117.080656 251.008984 163.5717 301.360064 112.111659 50.543015-51.673302 4.947671-191.530305-109.637824-308.674939z" fill="#B03414" p-id="9502"></path><path d="M590.203054 115.310584a9.68208 9.68208 0 0 1 12.369177 6.013979c33.482082 96.436927 15.35484 177.433708-36.297136 248.215256-5.886022 8.061291-12.006632 15.717385-18.596418 23.373479l-8.061291 9.106273-17.700718 18.980289a9.618101 9.618101 0 0 1-13.6914 0.55448 9.895341 9.895341 0 0 1-0.533154-13.862008l17.615414-18.91631 1.27957-1.407527c8.807707-9.810037 16.63441-19.321507 24.077243-29.494089 48.090506-65.897856 64.746243-140.326178 33.610038-230.045362a9.852689 9.852689 0 0 1 5.928675-12.51846z" fill="#17BA55" p-id="9503"></path><path d="M677.149836 535.905247c92.704847-69.54463 183.149121-92.982087 271.140885-44.187818 4.691757 2.601792 6.39785 8.573119 3.838711 13.328854a9.639427 9.639427 0 0 1-13.179572 3.881363c-79.823843-44.273122-162.953241-22.733694-250.241241 42.737638a626.776044 626.776044 0 0 0-35.038893 28.427781l-36.041222 32.053228-2.025985 1.706094a9.618101 9.618101 0 0 1-13.648747-1.428853 9.895341 9.895341 0 0 1 1.428853-13.819357l28.363802-25.250181a689.709562 689.709562 0 0 1 45.403409-37.448749z" fill="#FC5965" p-id="9504"></path><path d="M735.071705 284.448413a9.703406 9.703406 0 0 1 11.68674 7.272223c12.753048 54.381725-20.174554 105.671157-83.662553 156.17152-9.852689 7.826703-20.089249 15.376166-31.200182 23.074913l-19.406812 13.051614-19.577421 12.7957a9.639427 9.639427 0 0 1-13.435485-2.857706 9.895341 9.895341 0 0 1 1.27957-12.326525l1.642115-1.322222 30.219178-19.854661c14.07527-9.490144 26.615056-18.553765 38.493731-28.001258 58.092479-46.192477 87.224022-91.57456 76.774201-136.188901a9.810037 9.810037 0 0 1 7.186918-11.814697z" fill="#FFD217" p-id="9505"></path><path d="M273.232236 239.364897l-0.213262-3.540144a35.870613 35.870613 0 0 0-2.985663-10.876345 44.934234 44.934234 0 0 0-5.67276-9.148926 94.453593 94.453593 0 0 0-11.302869-11.836022l-5.096954-4.414517-16.293191-13.52079c-25.889967-21.710038-36.254484-37.064878-33.71667-56.57832 3.625448-28.171866 17.977959-41.628678 45.382083-42.716312a9.767384 9.767384 0 0 0 9.319535-10.193908 9.746058 9.746058 0 0 0-10.087277-9.426166c-36.915595 1.492832-59.009504 22.179214-63.850544 59.777246-3.497491 26.934949 8.615771 46.533696 36.105201 70.440329l21.880647 18.276525c5.736739 4.947671 9.68208 8.829033 12.433155 12.369177 1.471506 1.855377 2.537814 3.56147 3.220252 5.11828a16.058604 16.058604 0 0 1 1.364874 4.905018c0.895699 8.189248-4.371864 18.169894-15.418818 30.496419l-4.137277 4.39319-13.179571 13.328854-4.926344 5.267564a9.895341 9.895341 0 0 0 1.215591 13.819356c3.604122 3.049642 8.743728 2.985663 12.262546 0.149283l5.694087-5.907348 13.90466-14.053944c15.738711-16.570432 24.397135-30.858963 24.098569-46.128499z" fill="#CF411C" p-id="9506"></path><path d="M742.685147 823.829826l3.518817 0.255914c3.668101 0.405197 7.272223 1.407527 10.748388 3.006989 3.049642 1.407527 6.035305 3.326882 9.042295 5.715413 3.753405 2.985663 7.464158 6.67509 11.68674 11.452151l4.39319 5.139607 13.35018 16.485127c21.454124 26.209859 36.659681 36.659681 55.959862 34.121867 27.830648-3.689427 41.138176-18.19122 42.225811-45.936564a9.746058 9.746058 0 0 1 10.06595-9.404839c5.374194 0.213262 9.532797 4.777061 9.319535 10.193907-1.471506 37.342118-21.944626 59.691941-59.094808 64.618286-26.657709 3.497491-46.021868-8.743728-69.651261-36.55305l-18.063263-22.136561a91.851801 91.851801 0 0 0-12.219894-12.582439 25.356812 25.356812 0 0 0-5.054301-3.241577 15.610754 15.610754 0 0 0-4.84104-1.386201c-8.12527-0.895699-17.977959 4.435843-30.1552 15.610754l-4.371864 4.158603-13.179572 13.35018-3.924014 3.83871a35.081544 35.081544 0 0 1-1.27957 1.151613 9.618101 9.618101 0 0 1-13.648747-1.236917 9.895341 9.895341 0 0 1-0.149283-12.41183l5.843369-5.758065 13.883335-14.07527c16.399822-15.887994 30.496419-24.653049 45.595345-24.354482zM356.318982 1.748746a9.639427 9.639427 0 0 1 13.499464 2.473835c33.524734 48.900901 44.891581 117.848398 13.456811 218.166687a9.68208 9.68208 0 0 1-12.155915 6.39785 9.831363 9.831363 0 0 1-6.333872-12.326524c29.579393-94.410941 19.236203-157.045893-10.918997-201.063102a9.895341 9.895341 0 0 1 2.452509-13.648746zM709.821524 203.089087a19.620074 19.620074 0 0 1 19.364159 19.812009 19.620074 19.620074 0 0 1-19.364159 19.833335 19.620074 19.620074 0 0 1-19.406812-19.833335 19.620074 19.620074 0 0 1 19.406812-19.833335z" fill="#FD9816" p-id="9507"></path><path d="M477.217022 222.901096a19.620074 19.620074 0 0 1 19.385486 19.833335 19.620074 19.620074 0 0 1-19.406812 19.790683 19.620074 19.620074 0 0 1-19.36416-19.812009 19.620074 19.620074 0 0 1 19.385486-19.833335z" fill="#FC5965" p-id="9508"></path><path d="M787.34214 539.957219a19.620074 19.620074 0 0 1 19.385486 19.812009 19.620074 19.620074 0 0 1-19.385486 19.812009 19.620074 19.620074 0 0 1-19.385485-19.833336 19.620074 19.620074 0 0 1 19.406811-19.790682z" fill="#17BA55" p-id="9509"></path><path d="M903.633728 282.358449a19.620074 19.620074 0 0 1 19.406812 19.812009 19.620074 19.620074 0 0 1-19.406812 19.812009 19.620074 19.620074 0 0 1-19.364159-19.833335 19.620074 19.620074 0 0 1 19.364159-19.812009z" fill="#CF411C" p-id="9510"></path><path d="M453.736912 81.359327l-13.307528-12.561113 17.679392-4.051971c18.041937-4.158603 35.038892-17.807349 46.917567-37.662011l11.644088-19.449464 0.55448 22.776346c0.575807 23.288174 8.637098 43.782621 22.221866 56.620973l13.328854 12.539786-17.679392 4.051972c-18.041937 4.179929-35.060218 17.807349-46.917567 37.683337l-11.644087 19.449464-0.554481-22.797673c-0.575807-23.266848-8.637098-43.782621-22.243192-56.599646zM895.231218 576.16905l8.40251-16.421149 8.423836 16.421149c8.594445 16.741041 25.889967 30.005917 47.727961 36.595702l21.390146 6.440503-21.390146 6.461828c-21.837995 6.589786-39.133516 19.833335-47.727961 36.595702l-8.423836 16.399823-8.40251-16.399823c-8.594445-16.741041-25.889967-30.005917-47.727961-36.595702l-21.390145-6.461828 21.390145-6.440503c21.837995-6.611112 39.133516-19.854661 47.727961-36.595702z" fill="#FFE20D" p-id="9511"></path></svg>
                    </div>
                }
            </div>
        </Card>

        // overview 模块
        const lockIcon = (plan = 2) => {
            return <div className='PAY_ICON' onClick={(e) => {
                e.stopPropagation();
                this.jumpPageUrl("/plan")
            }}>
                {plan === 2 ? t("Pro plan unlock") : t("Pre plan unlock")} <Icon source={LockMajor} tone="base" />
            </div>
        } // 升级图标
        const websiteOverview = isShowWebSpeed && <Card>
            <Text variant="headingMd" as="h2">
                {t("Website optimization overview")}
                <span className='website_plan'>
                    &nbsp;({level === 2 ? t("Pro plan") : level === 3 ? t("Pre plan") : t("Free plan")})&nbsp;
                    {level !== 3 && <span onClick={() => this.jumpPageUrl("/plan")}>{t("Upgrade")}</span>}
                </span>
            </Text>
            <div className='website_overview'>
                <div className='website_item opt_images' onClick={() => this.jumpPageUrl("/speedOpt/PageSpeed")}>
                    <p>{t("Optimized images")}</p>
                    <span>{optImages}</span>
                </div>
                <div className='website_item re_broken_link' onClick={() => this.jumpPageUrl("/backlinks/broken-link/view-errors")}>
                    <p>{t("Repaired broken links")}</p>
                    <span>{repBrokenlinks}</span>
                </div>
                <Tooltip content={t("This is an estimated value of the money you have saved by using SEOAnt.")}>
                    <div className='website_item est_save_cost' onClick={() => this.jumpPageUrl("/dashboard/recent-improvements")}>
                        <p>{t("Estimated saved cost")}</p>
                        {
                            saveCost !== -1 ? <span>${saveCost}</span> : <Spinner size='small' />
                        }
                    </div>
                </Tooltip>
            </div>
            <div className='website_quota_main'>
                <div className='website_quota' style={{
                    borderBottom: isShowQuotaPanel ? '1px solid #eee' : ''
                }} onClick={this.changeQuotaViewState}>
                    <div className='website_all'>
                        {
                            isAddImageQuota ?
                                <div className="website_progress website_image_progress">
                                    <label>{t("Image Quota")}: {imageUse} / {imageAll + 200}</label>
                                    <div className={`${(!Boolean(imageAll) || Number(imageUse / (imageAll + 200)) <= 0.8) ? 'ProgressBarGreen' : 'ProgressBarRed'}`} title={(100 * (imageUse / (imageAll + 200))).toFixed(2) + "%"}>
                                        <ProgressBar animated={false} progress={!Boolean(imageAll) ? 0 : (100 * Number((imageUse / (imageAll + 200)).toFixed(2)))} size="small" />
                                    </div>
                                </div> :
                                <div className="website_progress website_image_progress">
                                    <label>{t("Image Quota")}: {imageUse} / {imageAll}</label>
                                    <div className={`${(!Boolean(imageAll) || Number(imageUse / imageAll) <= 0.8) ? 'ProgressBarGreen' : 'ProgressBarRed'}`} title={imagePro + "%"}>
                                        <ProgressBar animated={false} progress={!Boolean(imageAll) ? 0 : imagePro} size="small" />
                                    </div>
                                </div>
                        }
                        <div className="website_progress website_onpage_progress">
                            {
                                level !== 3 ? <>
                                    <label>{t("On-page SEO Scan Quota")}: {onpageUse} / {onpageAll}</label>
                                    <div className={`${(!Boolean(onpageAll) || (Number(onpageUse / onpageAll) <= 0.8)) ? 'ProgressBarGreen' : 'ProgressBarRed'}`} title={onpagePro + "%"}>
                                        <ProgressBar animated={false} progress={!Boolean(onpageAll) ? 0 : onpagePro} size="small" />
                                    </div>
                                </> : <>
                                    <label>{t("On-page SEO Scan Quota")}: {onpageUse} / {t("unlimited")}</label>
                                    <div style={{ marginTop: '5px' }}>
                                        <ProgressBar animated={false} progress={0} size="small" />
                                    </div>
                                </>
                            }
                        </div>
                        <div className="website_progress website_backlinks_progress">
                            <label>{t("Exchange Backlinks")}: {exchangeUse} / {exchangeAll}</label>
                            <div className={`${(!Boolean(exchangeAll) || Number(exchangeUse / exchangeAll) <= 0.8) ? 'ProgressBarGreen' : 'ProgressBarRed'}`} title={exchangePro + "%"}>
                                <ProgressBar animated={false} progress={!Boolean(exchangeAll) ? 0 : exchangePro} size="small" />
                            </div>
                        </div>
                    </div>
                    <div className='website_icon'>
                        <Icon source={!isShowQuotaPanel ? ChevronDownMinor : ChevronUpMinor} />
                    </div>
                </div>
                <Collapsible
                    id={"website_func_block"}
                    open={isShowQuotaPanel}
                    transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                >
                    {
                        Object.keys(websiteFuncList).map(item => {
                            return <div key={item} className='website_func'>
                                <div className='website_left'>
                                    <p className={`w_func_item web_first ${["Speed Optimization", "On-page SEO Scan", "Link Management"].includes(item) ? 'top_border' : ''}`}>
                                        <span className='w_func_main'>{t(item)}</span>
                                    </p>
                                </div>
                                <div className='website_right'>
                                    {
                                        Object.keys(websiteFuncList[item]).map((son, index) => {
                                            return <div key={son} className='website_func_son' onClick={() => this.jumpPageUrl(websiteFuncList[item][son].url)}>
                                                <div className={
                                                    `
                                                        w_func_son_item web_first 
                                                        ${["Speed Optimization", "On-page SEO Scan", "Link Management"].includes(item) && index === 0 ? 'top_border' : ''}
                                                        ${["SEO analysis", "Speed Optimization", "Search Appearance", "Link Management"].includes(item) && Object.keys(websiteFuncList[item]).length - 1 === index ? 'not_bottom_border' : ''}
                                                    `
                                                }>
                                                    <span className='w_func_son_obj'>{t(son)}</span>
                                                    {
                                                        ['SEO checker', 'Keyword Search'].includes(son) ? <Badge tone="success">{t("On")}</Badge> : (websiteFuncList[item][son].plan !== 1 && websiteFuncList[item][son].plan > level) ? (websiteFuncList[item][son].plan === 2 ? <div>{lockIcon(2)}</div> : <div>{lockIcon(3)}</div>) : son === 'Competitor Keywords Research' ?
                                                            (websiteFuncList[item][son].state?.status ? <Badge tone="info">{websiteFuncList[item][son].state.quota} {t("available")}</Badge> : <Badge>{t("Not added")}</Badge>) : son === 'On-page SEO' ?
                                                                (level === 3 ? <Badge tone="info">{t("Unlimited")}</Badge> : <Badge tone="info">{websiteFuncList[item][son].state} {t("available")}</Badge>) : typeof websiteFuncList[item][son].state === 'number' ?
                                                                    <Badge tone="info">{websiteFuncList[item][son].state} {t("available")}</Badge> : (typeof websiteFuncList[item][son].state === 'boolean' && Boolean(websiteFuncList[item][son].state)) ?
                                                                        <Badge tone="success">{t("On")}</Badge> : <Badge>{son === 'Google Analytics' ? t("Not connected") : t("Off")}</Badge>
                                                    }
                                                    <Icon source={ChevronRightMinor} />
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </Collapsible>
            </div>
        </Card>

        // 常见问题列表
        // const frequentlyBox = <div className='frequentlyBox'>
        //     <Card>
        //         <Text variant="headingMd" as="h2">{t("Frequently asked questions")}</Text>
        //         <span className="faq_box_tip">{t("If you have any questions you can")}&nbsp;<Button variant="plain" onClick={this.handleContactSer}>{t("contact us")}</Button>&nbsp;{t("anytime")}</span>
        //         <div className='fre_main'>
        //             {
        //                 frequentData.map(item => {
        //                     return <div className='fre_item' key={item.title}>
        //                         <div className='fre_title' onClick={() => this.handleColStatus(item)}><Text variant="headingSm" as="h6">{t(item.title)}</Text><Icon source={!item.status ? ChevronDownMinor : ChevronUpMinor} color='base' /></div>
        //                         <Collapsible
        //                             open={item.status}
        //                             id={`${item.id}-collapsible`}
        //                             transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
        //                             expandOnPrint
        //                         >
        //                             {
        //                                 item.id === 'AddCodeSEOant' ? <div className='fre_desc'>
        //                                     {t("Only the")}&nbsp;<Button variant="plain" onClick={() => {
        //                                         utils.routeJump(this, "/speedOpt/site-speedup");
        //                                     }}>{t("Site speed up")}</Button>&nbsp;{t("function will add code to your website, but it doesn't matter, it will not have any other impact on your website. If you turn off the function, the code will be deleted immediately.")}
        //                                 </div> :
        //                                     item.id === 'OnPageSEO' ?
        //                                         <div className='fre_desc'>
        //                                             {t("SEOAnt has integrated with ChatGPT, allowing our")}
        //                                             &nbsp;<Button variant="plain" onClick={() => {
        //                                                 utils.routeJump(this, "/on-page-seo");
        //                                             }}>{t("AI writer")}</Button>&nbsp;
        //                                             {t("to automatically generate content to help you resolve all of your On-Page SEO issues.")}</div> :
        //                                         <div className='fre_desc'>{t(item.desc)}</div>
        //                             }
        //                         </Collapsible>
        //                     </div>
        //                 })
        //             }
        //         </div>
        //     </Card>
        // </div>

        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />;

        // Feedback 反馈
        // const feedbackBox = <Card>
        //     {
        //         Boolean(this.state.ssoToken) ? <div className={`Feedback ${!isShowFeedbackAll ? 'FB_box' : ''}`} style={{ display: Boolean(this.state.isShowStatus) ? 'block' : 'none' }}>
        //             <Feedback ssoToken={this.state.ssoToken} sendBackStatus={() => this.sendBackStatus()} />
        //         </div> : null
        //     }
        //     <div style={{ display: Boolean(this.state.isShowStatus) ? 'none' : 'block' }}>
        //         <div className="DetailReport_Empty_New_div_margin_800">
        //             <Spinner size="large" color="teal" />
        //         </div>
        //     </div>
        //     {
        //         Boolean(this.state.isShowStatus) ? <div className='FB_title'>
        //             {/* <Button variant='plain' onClick={this.toggleFeedback}>{t("Expand to show")}</Button> */}
        //             <span className='col_action' onClick={this.toggleFeedback}>
        //                 <Icon source={!Boolean(isShowFeedbackAll) ? ChevronDownMinor : ChevronUpMinor} />
        //             </span>
        //         </div> : null
        //     }
        // </Card>

        // 视频弹窗
        const videoModal = <Modal title={t("How to Use SEOAnt to Optimize Your Website?")}
            size="large"
            open={openVideo}
            onClose={() => {
                this.setState({ openVideo: false, })
            }}>
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/MyntimPM4Rs?si=5KsF71s455jBu5Jg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </Modal>

        // 帮助模块
        const NeedHelpBox = <div id='NeedHelpBox'>
            <Card>
                <Text variant="headingMd" as="h2">{t("Support")}</Text>
                <div className='need_help_box'>
                    <div className={`GetHelpItem ${isVideoAnimate ? 'GetHelpItemAni' : ''}`} onClick={() => this.handleHelpBlock('tutorial_video')}>
                        <Icon source={TutorialIcon}></Icon>
                        <BlockStack gap={100}>
                            <Text as="p" fontWeight="semibold">{t("SEOAnt tutorial videos")}</Text>
                            {/* <Text as="p" color="subdued">{t("Introducing how to use the SEOAnt, including core features such as SEO checker, site speed up、on-page optimization.")}</Text> */}
                            <Text as="p" color="subdued">{t("Learn how to optimize your website with SEOAnt")}</Text>
                        </BlockStack>
                    </div>
                    <div className='GetHelpItem' onClick={() => this.handleHelpBlock('help_center')}>
                        <Icon source={NewHelpCenterIcon}></Icon>
                        <BlockStack gap={100}>
                            <Text as="p" fontWeight="semibold">{t("SEOAnt help center")}</Text>
                            <Text as="p" color="subdued">{t("Make use of our documents to get help")}</Text>
                        </BlockStack>
                    </div>
                    <div className='GetHelpItem' onClick={() => this.handleHelpBlock('feature_request')}>
                        <Icon source={ClearCodeIcon}></Icon>
                        <BlockStack gap={100}>
                            <Text as="p" fontWeight="semibold">{t("Feature request")}</Text>
                            <Text as="p" color="subdued">{t("Recommend features for future updates")}</Text>
                        </BlockStack>
                    </div>
                </div>
            </Card>
        </div>

        // 广告模块
        const adverBox = (adverList.length > 0 && isShowAdver) && <div className='adverBox'>
            <Card>
                <div className='adver_box_title'>
                    <Text variant="headingMd" as="h2">{t("Boost your sales with leading apps.")}</Text>
                    <div className='flex_layout' style={{ columnGap: '1.2em' }}>
                        <Button icon={ViewMinor} variant='plain' onClick={() => this.jumpAppRecommand()}>{t("View more")}</Button>
                        <Popover
                            active={adverShowMore}
                            activator={<span style={{ cursor: 'pointer' }} onClick={() => {
                                this.setState({
                                    adverShowMore: !adverShowMore
                                })
                            }}><Icon source={MobileHorizontalDotsMajor} color='base' /></span>}
                            autofocusTarget="first-node"
                            onClose={() => {
                                this.setState({
                                    adverShowMore: false
                                })
                            }}
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: t("Dismiss"),
                                        icon: CancelMajor,
                                        onAction: this.closeAdverBox
                                    },
                                    // { 
                                    //     content: t("View more"), 
                                    //     icon: EyeDropperMinor,
                                    //     onAction: this.jumpAppRecommand
                                    // }
                                ]}
                            />
                        </Popover>
                    </div>
                </div>
                <div className='adver_swiperbox' onMouseLeave={() => { }}>
                    <Swiper
                        slidesPerView={"auto"}
                        loop={adverList.length > 1 ? true : false}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false
                        }}
                        modules={[Autoplay, Pagination, Navigation]}
                        pagination={{
                            clickable: true,
                        }}
                        touchRatio={0.5}
                        spaceBetween={10}
                        initialSlide={0}
                    >
                        {adverList.map((item, index) => {
                            return <SwiperSlide key={index}>
                                {Boolean(item.img_url) ? <img className='show_adver_img' src={item.img_url} alt={item.id} onClick={() => jumpTargetUrl(item.id, item.jump_url)} /> : <div className='halfspace'></div>}
                                <div className='adver_app_list'>
                                    {
                                        (Boolean(item.list) && item.list.length > 0) && item.list.map((app, inx) => {
                                            return <div key={inx} className='app_main' onClick={() => jumpTargetUrl(app.id, app.jump_url)}>
                                                <div className='app_img_block'><img className='app_img' src={app.img_url} alt={app.id} /></div>
                                                <BlockStack>
                                                    <Text as="p" fontWeight="semibold">{app.app_name}</Text>
                                                    <Text as="p" color="subdued">{app.desc}</Text>
                                                </BlockStack>
                                            </div>
                                        })
                                    }
                                </div>
                            </SwiperSlide>
                        })}
                    </Swiper>
                </div>
            </Card>
        </div>

        // 新功能
        const startNew = <svg t="1716187539768" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14457" width="20" height="20"><path d="M411.648 886.784L297.472 626.176 88.064 512l209.408-114.176 114.176-260.608 114.176 260.608L735.232 512 525.824 626.176zM806.912 366.08l-45.568-103.424-82.944-45.568 82.944-45.568 45.568-103.424L852.48 171.52l83.456 45.568-83.456 45.568z m0 589.824L761.344 852.48 678.4 806.912l82.944-45.568 45.568-103.424 45.568 103.424 83.456 45.568-83.456 45.568z" p-id="14458" fill="#fbdf3a" data-spm-anchor-id="a313x.search_index.0.i2.71b33a81zeJoEz" className="selected"></path></svg>
        const newFunctions = <Popover
            active={isShowNewFunc}
            activator={FBLoading ? <div className='new_function func_loading'>
                <Spinner size='small' />
            </div> : <div className='new_function flex_layout' onClick={this.openNewFuncsModal}>
                <p>{t("What's new")}</p>
                {/* {startNew} */}
                {/* <span className={`func_nums ${isShowFuncNums ? 'func_nums_show' : ''}`}>4</span> */}
            </div>}
            fluidContent
            preferredAlignment={'right'}
            onClose={() => this.setState({ isShowNewFunc: false })}
        >
            <div className='funcContainer'>
                <div className='funcTitle flex_layout'>
                    <Text variant="headingMd" as="h2">{t("New feartures")}</Text>
                    {startNew}
                </div>
                <div className='funcMain'>
                    {
                        newFuncList.map(item => {
                            return <div className='funcItems' key={item.id} onClick={() => this.jumpPageUrl(item.title === "Add to-do items" ? 'pending' : item.title === "New SEOAnt User Guide" ? "NewSEOAntUserGuide" : item.url)}>
                                <div className='flex_layout'>
                                    <Text variant="headingMd" as="h2">{t(item.title)}</Text>
                                    <span>{item.date}</span>
                                </div>
                                <Text as="p" tone="subdued">{t(item.desc)}</Text>
                            </div>
                        })
                    }
                </div>
            </div>
        </Popover>

        // 任务福利
        const taskFunctions = <Popover
            active={isShowTask}
            activator={<div className='task_plat' onClick={this.openTaskPop}>
                <img src="/gift/stimulate.png" alt="" />
            </div>}
            preferredAlignment={'right'}
            onClose={() => this.setState({ isShowTask: false })}
        >
            <div className='task_pop'>
                <div className='flex_layout compose_item' onClick={() => this.toggleTaskModal("isShowFeedback", true)}>
                    <span><Icon source={ComposeMajor} tone='base' /></span>
                    <div>
                        <Text variant="headingMd" as="h2">{t("Submit your valuable feedback")}</Text>
                        <Text as="p" tone="subdued">{t("Get 200 image compression quotas in just 1 minute")}</Text>
                    </div>
                </div>
                <p className='task_line'></p>
                <div className='flex_layout share_item' onClick={() => this.toggleTaskModal("isShowSharePlat", true)}>
                    <span><Icon source={ShareMinor} tone='base' /></span>
                    <div>
                        <Text variant="headingMd" as="h2">{t("Share 30% off with your friends")}</Text>
                        <Text as="p" tone="subdued">{t("Get {{v1}} AI credits in just one click to share", 20)}</Text>
                    </div>
                </div>
            </div>
        </Popover>

        // 页面主内容
        const goPageSpeedBtn = <div className='SEO_Score_btn'>
            <Button onClick={() => this.jumpToPage('/speedOpt/site-speedup')}>{t("Improve it")}</Button>
        </div>
        const finishIconGreen = <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="DdVKM"><circle cx="12" cy="12" r="10" fill="#007f5f"></circle><path d="M17.2738 8.52629C17.6643 8.91682 17.6643 9.54998 17.2738 9.94051L11.4405 15.7738C11.05 16.1644 10.4168 16.1644 10.0263 15.7738L7.3596 13.1072C6.96908 12.7166 6.96908 12.0835 7.3596 11.693C7.75013 11.3024 8.38329 11.3024 8.77382 11.693L10.7334 13.6525L15.8596 8.52629C16.2501 8.13577 16.8833 8.13577 17.2738 8.52629Z" fill="#fff"></path></svg>
        const pageMain = <div className="page_main_content">
            <BlockStack gap={400}>
                <Layout>
                    <Layout.Section variant='oneHalf'>
                        <Card>
                            <div className='Seo_site_score'>
                                <Tooltip content={t("Shop SEO score represents how well your website is optimized for search engines. It assesses the different criteria that Google and other search engines use to rank websites in their search listings.")}>
                                    <label className='main_top_title'>{t("SEO Score")}</label>
                                </Tooltip>
                                <p className='SEO-time-scan'>{t("Last scan")}: {scanTime}.</p>
                            </div>
                            <div id='SEOScore' style={{ width: "100%", height: "9rem", marginTop: '2rem' }}></div>
                            <div className='SEO-issues-type'>
                                <div className='issues-top' style={{ columnGap: '1.5em', whiteSpace: 'normal' }}>
                                    <p className='issues-item'>
                                        <svg width="18" height="16" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M7.96798 1.16592C8.85365 -0.388639 11.1464 -0.388642 12.032 1.16592L19.7041 14.6324C20.5649 16.1433 19.4445 18 17.6721 18H2.32789C0.555459 18 -0.564896 16.1433 0.29587 14.6324L7.96798 1.16592ZM10.9999 14C10.9999 14.5523 10.5522 15 9.99994 15C9.44765 15 8.99994 14.5523 8.99994 14C8.99994 13.4477 9.44765 13 9.99994 13C10.5522 13 10.9999 13.4477 10.9999 14ZM10.7499 6C10.7499 5.58579 10.4142 5.25 9.99994 5.25C9.58573 5.25 9.24994 5.58579 9.24994 6V11C9.24994 11.4142 9.58573 11.75 9.99994 11.75C10.4142 11.75 10.7499 11.4142 10.7499 11V6Z" fill="#e61523" />
                                        </svg>
                                        <span>{importantIssues} {t("Important issues")}</span>
                                    </p>
                                    <p className='issues-item'>
                                        <svg t="1713774171125" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13045" width="20" height="20"><path d="M512 64C264.32 64 64 264.32 64 512s200.32 448 448 448 448-200.32 448-448S759.68 64 512 64zM512 768c-35.2 0-64-28.8-64-64 0-35.2 28.8-64 64-64 35.2 0 64 28.8 64 64C576 739.2 547.2 768 512 768zM576 512c0 35.2-28.8 64-64 64C476.8 576 448 547.2 448 512L448 320c0-35.2 28.8-64 64-64 35.2 0 64 28.8 64 64L576 512z" p-id="13046" fill="#fcc503"></path></svg>
                                        <span>{needImprove} {t("Needs improvement")}</span>
                                    </p>
                                </div>
                                <p className='issues-item'>
                                    {finishIconGreen}
                                    <span>{goodResult} {t("Good results")}</span>
                                </p>
                            </div>
                            {/* <p className='SEO-time-scan'>{t("Last scan time")}: {scanTime}.</p> */}
                            {/* <div className='SEO_Score_btn'><Button onClick={() => this.jumpToPage('/website-check')}>{t("Improve it")}</Button></div> */}
                            <div className='SEO_Score_btn'>
                                <Button onClick={() => this.jumpToPage('/website-check')} icon={SearchResource}>
                                    {t("View checklist")}
                                </Button>
                            </div>
                        </Card>
                    </Layout.Section>
                    <Layout.Section variant='oneHalf'>
                        <Card>
                            <div className='speed_score_home'>
                                <Tooltip content={t("The speed score indicates how fast a website loads. A high speed score is crucial for both user experience and search engine optimization.")}>
                                    {/* <label className='main_top_title'>{t("Google Speed Score")}</label> */}
                                    <label className='main_top_title'>{t("Speed Score")}</label>
                                </Tooltip>
                                {
                                    Boolean(passwordStatus) ? <Tooltip content={t("Your store requires a password to access.")}>
                                        <Button variant='plain' disabled={true} loading={RecheckButtonLoading}>{t("Recheck")}</Button>
                                    </Tooltip> : <Button variant='plain' loading={RecheckButtonLoading} onClick={this.handleBackRecheck}>{t("Recheck")}</Button>
                                }
                            </div>
                            <div className='google_score_table' style={{ columnGap: '2em' }}>
                                <div id='MobileScore' style={{ width: "35%", height: "212px" }}></div>
                                <div id='PCScore' style={{ width: "35%", height: "212px" }}></div>
                            </div>
                            {(googleState ? <div className='enable_feature'>
                                <div className='SEO_Score_btn'>
                                    <Button onClick={() => this.jumpToPage('/speedOpt/site-speedup')} icon={LightningIcon} variant='primary'>{t("Speed up")}</Button>
                                </div>
                            </div> : goPageSpeedBtn)}
                        </Card>
                    </Layout.Section>
                </Layout>

                {/* 新手引导 */}
                {UserGuide}

                {/* pending列表 */}
                {pendindList}

                {/* 数据概览 */}
                {websiteOverview}

                {/* 常见问题 */}
                {/* {frequentlyBox} */}
                {FrequentlyItems}

                {/* 反馈 */}
                {/* {feedbackBox} */}

                {/* 帮助模块 */}
                {videoModal}
                {NeedHelpBox}

                {/* 广告列表 */}
                {adverBox}
            </BlockStack>
        </div>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageEndContent = <div className='DashboardContent'>
            {!this.state.dashboardData.status || adverloading ? <SkeltonLoading /> : <Page
                title={<div className='home_title'>
                    <div className='SEOAnt_sign'>
                        <img src='/Image/newlogo.png' alt='newlogo.png' />{t("SEOAnt")}
                    </div>
                    {/* <div>
                        {this.timePeriodString}{','} {' '} {Boolean(this.state.dashboardData.publicInit.shop_data) && this.state.dashboardData.publicInit.shop_data.shop_owner} 👋 😊 
                    </div> */}
                    <Text variant='headingLg' as='h2'>
                        {/* {t("Welcome to SEOAnt by")}&nbsp; */}
                        <Button variant='plain' onClick={this.goSolutionExpert}>{t("by Channelwill")}</Button>
                        {/* <Button variant='plain' onClick={this.goSolutionExpert}>{t("Join Channelwill BFCM Sale-Up to 50% Off!👈")}</Button> */}
                    </Text>
                </div>}
                subtitle={t("Ready to take your store up a notch and get more organic traffic?")}
            // secondaryActions={[
            //     {
            //         content: <span className='flex_layout'>
            //             <span>{t("What's new")}</span>
            //             {/* {FBLoading ? null : startNew} */}
            //             {
            //                 FBLoading ? null : <span className={`func_nums ${isShowFuncNums ? 'func_nums_show' : ''}`}>4</span>
            //             }
            //         </span>,
            //         loading: FBLoading,
            //         onAction: this.openNewFuncsModal,
            //     },
            //     {
            //         content: 'GIFT',
            //         onAction: this.openTaskPop
            //     }
            // ]}
            >
                <title>SEOAnt - Dashboard</title>
                <div className='home_top_task'>
                    {/* 新功能 */}
                    {newFunctions}
                    {/* 任务福利 */}
                    {taskFunctions}
                </div>
                <BlockStack gap={400}>
                    {/* Banner模块 */}
                    {embedBanner}
                    {AiOnpageBanner}
                    {reAppBanner}
                    {reviewBanner}
                    {AffiliateBanner}

                    {pageMain}
                </BlockStack>

                {/* App公告 */}
                {/* <AppNotification show={!this.state.AppNotificationShow} /> */}

                {/* {imageShowModal} */}

                {/* {quotaImgModal} */}

                {/* 底部 */}
                {FooterHelpBox}
            </Page>}
            {/* {DiscountPopupBox} */}
            {/* {gift} */}
            <div className="halfspace"></div>
        </div>

        return pageEndContent;
    }
}

// 乱序数组
// function shuffleArrayData(array) {
//     for (let i = array.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [array[i], array[j]] = [array[j], array[i]];
//     }
//     return array;
// }

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    setSeoData(val) {
        dispatch(setSeoPageScoreData(val));
    },

    // 设置评价状态
    setStartReview(states) {
        dispatch(saveStartReview(states))
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['speedAnalysis', data]));
    },

    // 设置支付回调提示状态
    setPayTipState(data) {
        dispatch(savePayTip(data));
    },

})

dashboardClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(dashboardClass);

export default withRouter(dashboardClass);